import { IPerformer } from "shared/models/Performers";

const performerResponse = [
  {
    id: "b375b80a-0809-4e2b-873b-0c9ea07ba1a5",
    artistRef: "M177783",
    mainPhoto: {
      id: "941d5e67-6d73-4a53-ba73-800fa79f217a",
      fileName: "M00177783-0101",
      description: "",
      photographer: {
        name: "MUG Photography",
      },
    },
    galleryPhotos: [
      {
        position: 3,
        isHidden: false,
        id: "77e804a4-b6b7-4f64-a909-6ec7052a9645",
        fileName: "M00177783-0105",
        description: "",
        photographer: {
          name: "MUG Photography",
        },
      },
      {
        position: 1,
        isHidden: false,
        id: "d0021baf-4144-4af0-90cd-c3cde2a13fd3",
        fileName: "M00177783-0102",
        description: "",
        photographer: {
          name: "MUG Photography",
        },
      },
      {
        position: 2,
        isHidden: false,
        id: "970cfcf1-100c-479b-bfb4-d4c2a6b0806d",
        fileName: "M00177783-0106",
        description: "",
        photographer: {
          name: "MUG Photography",
        },
      },
    ],
    forename: "LUKE",
    surname: "ANTHONY",
    performerType: "Performer",
    publicationCode: 1,
    contract: {
      membership: "performerfamily",
      status: "current",
      expirationDate: "2020-05-12T00:00:00+00:00",
    },
    mainAgent: {
      agentRef: 11923,
      name: "SQUARE MILE MANAGEMENT",
      email: "enquiries@spotlight.com",
      phone: "020 7437 7631",
      mobilePhone: "020 7437 7631",
      website: "www.spotlight.com",
      address: {
        id: 111,
        addressLine1: "Spotlight",
        addressLine2: "7 Leicester Place",
        addressLine3: "London",
        addressLine4: "",
        country: "",
        postCode: "WC2H 7RJ",
      },
    },
    agents: [
      {
        agentRef: 11923,
        name: "SQUARE MILE MANAGEMENT",
        email: "enquiries@spotlight.com",
        phone: "020 7437 7631",
        mobilePhone: "020 7437 7631",
        website: "www.spotlight.com",
        address: {
          id: 111,
          addressLine1: "Spotlight",
          addressLine2: "7 Leicester Place",
          addressLine3: "London",
          addressLine4: "",
          country: "",
          postCode: "WC2H 7RJ",
        },
      },
      {
        agentRef: 3455,
        name: "MOUNTVIEW",
        email: "enquiries@spotlight.com",
        phone: "020 7437 7631",
        mobilePhone: "020 7437 7631",
        website: "www.spotlight.com",
        address: {
          id: 111,
          addressLine1: "Spotlight",
          addressLine2: "7 Leicester Place",
          addressLine3: "London",
          addressLine4: "",
          country: "",
          postCode: "WC2H 7RJ",
        },
      },
    ],
    dramaSchools: [],
    showreelsCount: 1,
    audioclipsCount: 8,
    locations: [],
    castingDirectorNotes: [],
    gender: [5203],
    disabilities: [],
    nationalities: [],
    appearances: [1716, 1708, 1711],
    eyeColours: [247],
    facialHairs: [256],
    hairColours: [262],
    hairLength: [277],
    beltNotes: [],
    accentsAndDialects: [
      {
        facetId: 44,
        levelId: 1,
      },
      {
        facetId: 29,
        levelId: 1,
      },
      {
        facetId: 38,
        levelId: 1,
      },
      {
        facetId: 163,
        levelId: 2,
      },
      {
        facetId: 20,
        levelId: 1,
      },
      {
        facetId: 43,
        levelId: 1,
      },
      {
        facetId: 5,
        levelId: 1,
      },
    ],
    vehicleLicences: [
      {
        facetId: 225,
      },
    ],
    languages: [
      {
        facetId: 294,
        levelId: 4,
      },
    ],
    musicAndDance: [
      {
        facetId: 715,
        levelId: 6,
      },
      {
        facetId: 684,
        levelId: 6,
      },
      {
        facetId: 657,
        levelId: 5,
      },
      {
        facetId: 690,
        levelId: 5,
      },
    ],
    otherSkills: [
      {
        facetId: 1027,
      },
      {
        facetId: 926,
      },
      {
        facetId: 883,
      },
      {
        facetId: 929,
      },
      {
        facetId: 954,
      },
      {
        facetId: 918,
      },
      {
        facetId: 903,
      },
      {
        facetId: 1216,
      },
      {
        facetId: 891,
      },
    ],
    performances: [
      {
        facetId: 1342,
        levelId: 7,
      },
      {
        facetId: 1328,
        levelId: 7,
      },
      {
        facetId: 1334,
        levelId: 7,
      },
    ],
    sports: [
      {
        facetId: 1738,
        levelId: 10,
      },
      {
        facetId: 1750,
        levelId: 9,
      },
      {
        facetId: 1732,
        levelId: 9,
      },
      {
        facetId: 1837,
        levelId: 9,
      },
      {
        facetId: 1753,
        levelId: 9,
      },
      {
        facetId: 1780,
        levelId: 10,
      },
      {
        facetId: 1730,
        levelId: 10,
      },
      {
        facetId: 1729,
        levelId: 10,
      },
      {
        facetId: 1749,
        levelId: 9,
      },
      {
        facetId: 1751,
        levelId: 10,
      },
    ],
    presenting: [],
    measurements: [
      {
        measurementType: "Height",
        value: 175,
      },
    ],
    credits: [
      {
        typeId: 43,
        role: "Care Worker",
        name: "Sitting Comfortably",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "Geraldine Pilgrim Performace Company",
        director: "Geraldine Pilgrim",
        highlighted: false,
        position: 27,
      },
      {
        typeId: 3,
        role: "Pinky",
        name: "Pinky",
        dateTo: "2018-01-01T00:00:00+00:00",
        company: "ESA Films",
        director: "Zah Ahmed",
        highlighted: false,
        position: 1,
      },
      {
        typeId: 0,
        role: "Carer",
        name: "Sitting Comfortably",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "Geraldine Pilgrim Production Company",
        director: "Geraldine Pilgrim",
        highlighted: false,
        position: 6,
      },
      {
        typeId: 4,
        role: "Hero - Steam Kitchen",
        name: "Whatever is on your mind, It's normal to us",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "BUPA",
        director: "Simon Ratigan",
        highlighted: false,
        position: 31,
      },
      {
        typeId: 6,
        role: "Dracula",
        name: "Hotel Transylvania",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "Smile Theatre",
        director: "Franca Relandini",
        highlighted: false,
        position: 23,
      },
      {
        typeId: 0,
        role: "Tybalt/Friar Laurence",
        name: "Romeo and Juliet",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "Young Shakespeare Company",
        director: "Martha Geelan",
        highlighted: false,
        position: 5,
      },
      {
        typeId: 16,
        role: "Dancer",
        name: "HIP HOP KINGZ",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "U.M.A.",
        director: "",
        highlighted: false,
        position: 22,
      },
      {
        typeId: 16,
        role: "Dancer",
        name: "Turbulence",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "U.M.A.",
        director: "",
        highlighted: false,
        position: 21,
      },
      {
        typeId: 0,
        role: "Eilert Loevborg",
        name: "HEDDA GABLER",
        dateTo: "2013-01-01T00:00:00+00:00",
        company: "Mountview",
        director: "Jeanette Smith",
        highlighted: false,
        position: 13,
      },
      {
        typeId: 0,
        role: "Johnny Byron/Gangster No1",
        name: "AIS Showcase",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Actors In Session",
        director: "Liam Reilly",
        highlighted: false,
        position: 2,
      },
      {
        typeId: 26,
        role: "Various roles",
        name: "One Good Man",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "Zoetrope Collective",
        director: "Eloise Lally",
        highlighted: false,
        position: 29,
      },
      {
        typeId: 35,
        role: "Gary/Teacher",
        name: "Chelseas Choice",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "Alter Ego",
        director: "Sean McGrath",
        highlighted: false,
        position: 25,
      },
      {
        typeId: 16,
        role: "Choreographer/Performer",
        name: "Open Art Surgery",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "Breaking Convention",
        director: "Anthony Ekundayo Lennon and UMA",
        highlighted: false,
        position: 19,
      },
      {
        typeId: 0,
        role: "Luke Prospect",
        name: "Gutted",
        dateTo: "2018-01-01T00:00:00+00:00",
        company: "Insight Theatre",
        director: "Rikki Beadle-Blair",
        highlighted: false,
        position: 4,
      },
      {
        typeId: 43,
        role: "Guide",
        name: "Well",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "Creative Barking and Dagenham",
        director: "Geraldine Pilgrim",
        highlighted: false,
        position: 26,
      },
      {
        typeId: 35,
        role: "Sherlock Holmes",
        name: "Sherlock Begins",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "Smile Theatre",
        director: "Franca Relandini",
        highlighted: false,
        position: 24,
      },
      {
        typeId: 1,
        role: "Bloke 1",
        name: "Eastenders",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "BBC",
        director: "Matthew Evans",
        highlighted: false,
        position: 30,
      },
      {
        typeId: 0,
        role: "Derek",
        name: "A Series of Unfortunate Break Ups",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "Some Riot Theatre",
        director: "Peter Taylor",
        highlighted: false,
        position: 7,
      },
      {
        typeId: 0,
        role: "Davey",
        name: "Jerusalem",
        dateTo: "2013-01-01T00:00:00+00:00",
        company: "Mountview",
        director: "Max Key",
        highlighted: false,
        position: 10,
      },
      {
        typeId: 16,
        role: "Dancer/Choreographer",
        name: "World Of Dance - U.M.A. Turbulence",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "U.M.A.",
        director: "",
        highlighted: false,
        position: 20,
      },
      {
        typeId: 0,
        role: "Little Charles",
        name: "AUGUST OSAGE COUNTY",
        dateTo: "2013-01-01T00:00:00+00:00",
        company: "Mountview",
        director: "Max Key",
        highlighted: false,
        position: 12,
      },
      {
        typeId: 0,
        role: "Tuckman",
        name: "Cruisin",
        dateTo: "2018-01-01T00:00:00+00:00",
        company: "Union Theatre / Canal Cafe",
        director: "Lucrezia Pollice",
        highlighted: false,
        position: 3,
      },
    ],
    creditHeadings: [
      {
        orderByDate: false,
        isHidden: false,
        position: 0,
        creditType: {
          id: 0,
          name: "Stage",
          hasVenue: true,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 2,
        creditType: {
          id: 1,
          name: "Television",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 1,
        creditType: {
          id: 3,
          name: "Feature Film",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 3,
        creditType: {
          id: 4,
          name: "Commercial",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 7,
        creditType: {
          id: 6,
          name: "Voice Over",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 4,
        creditType: {
          id: 16,
          name: "Dance",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 8,
        creditType: {
          id: 26,
          name: "Workshop",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 5,
        creditType: {
          id: 35,
          name: "Educational",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 6,
        creditType: {
          id: 43,
          name: "Site Specific",
          hasVenue: true,
        },
      },
    ],
    isPregnant: false,
    playingAgeFrom: 25,
    playingAgeTo: 32,
    dateOfBirthUtc: "1991-05-24T00:00:00+00:00",
    height: 175,
    viewPin: "3657-5617-5470",
    isVisibleActualAge: false,
    isVisibleDisability: false,
    isVisibleGender: false,
  },
  {
    id: "3690a7e9-0189-48be-a2e8-6e6d10ed5366",
    artistRef: "M261064",
    mainPhoto: {
      id: "aee84b01-7b00-4472-b344-b58d8320dcd4",
      fileName: "15278e59-34c7-4bc5-8c53-fce26e0e4214",
      description: "",
      photographer: {
        name: "A P Wilding",
      },
    },
    galleryPhotos: [
      {
        position: 2,
        isHidden: false,
        id: "1a808436-2b2c-40a8-b849-15c912e9176d",
        fileName: "bfdd090e-6731-4b1d-a4e9-b524c06d5358",
        description: "",
        photographer: {
          name: "A P Wilding",
        },
      },
      {
        position: 0,
        isHidden: false,
        id: "c03ce9d6-86f1-4247-aff8-16f7aca06cde",
        fileName: "df66fc7d-47d6-42f1-b7f9-9b06031452bd",
        description: "",
        photographer: {
          name: "A P Wilding",
        },
      },
      {
        position: 1,
        isHidden: false,
        id: "55780ce3-6d86-4bc9-87d6-7df7c19cb0eb",
        fileName: "304e1f78-15d0-48af-84b5-f65c743f012b",
        description: "",
        photographer: {
          name: "A P Wilding",
        },
      },
      {
        position: 3,
        isHidden: false,
        id: "a71d32e7-b0fc-40dd-81e3-a7581a9d7b16",
        fileName: "da6ca97d-2b3f-4048-8bbd-39991528e0a5",
        description: "",
        photographer: {
          name: "A P Wilding",
        },
      },
    ],
    forename: "LUKE",
    surname: "AQUILINA",
    performerType: "YoungPerformer",
    publicationCode: 16,
    contract: {
      membership: "youngperformerfamily",
      status: "current",
      expirationDate: "2020-05-12T00:00:00+00:00",
    },
    mainAgent: {
      agentRef: 14601,
      name: "AUDERE TALENT MANAGEMENT",
      email: "enquiries@spotlight.com",
      phone: "020 7437 7631",
      mobilePhone: "020 7437 7631",
      website: "www.spotlight.com",
      address: {
        id: 111,
        addressLine1: "Spotlight",
        addressLine2: "7 Leicester Place",
        addressLine3: "London",
        addressLine4: "",
        country: "",
        postCode: "WC2H 7RJ",
      },
    },
    agents: [
      {
        agentRef: 14601,
        name: "AUDERE TALENT MANAGEMENT",
        email: "enquiries@spotlight.com",
        phone: "020 7437 7631",
        mobilePhone: "020 7437 7631",
        website: "www.spotlight.com",
        address: {
          id: 111,
          addressLine1: "Spotlight",
          addressLine2: "7 Leicester Place",
          addressLine3: "London",
          addressLine4: "",
          country: "",
          postCode: "WC2H 7RJ",
        },
      },
    ],
    dramaSchools: [],
    showreelsCount: 4,
    audioclipsCount: 0,
    locations: [],
    castingDirectorNotes: [],
    gender: [5203],
    disabilities: [],
    nationalities: [2198],
    appearances: [1716, 1711],
    eyeColours: [249],
    facialHairs: [],
    hairColours: [262],
    hairLength: [277],
    beltNotes: [],
    accentsAndDialects: [
      {
        facetId: 5,
        levelId: 1,
      },
      {
        facetId: 51,
        levelId: 1,
      },
      {
        facetId: 38,
        levelId: 1,
      },
      {
        facetId: 63,
        levelId: 1,
      },
      {
        facetId: 44,
        levelId: 1,
      },
      {
        facetId: 53,
        levelId: 1,
      },
      {
        facetId: 20,
        levelId: 1,
      },
      {
        facetId: 55,
        levelId: 2,
      },
      {
        facetId: 162,
        levelId: 1,
      },
    ],
    vehicleLicences: [],
    languages: [
      {
        facetId: 294,
        levelId: 4,
      },
    ],
    musicAndDance: [
      {
        facetId: 581,
        levelId: 5,
      },
      {
        facetId: 580,
        levelId: 5,
      },
      {
        facetId: 617,
        levelId: 5,
      },
    ],
    otherSkills: [
      {
        facetId: 1239,
      },
      {
        facetId: 1223,
      },
      {
        facetId: 896,
      },
      {
        facetId: 1289,
      },
      {
        facetId: 934,
      },
      {
        facetId: 942,
      },
      {
        facetId: 891,
      },
      {
        facetId: 941,
      },
      {
        facetId: 883,
      },
    ],
    performances: [
      {
        facetId: 1369,
        levelId: 7,
      },
      {
        facetId: 1521,
        levelId: 7,
      },
      {
        facetId: 1413,
        levelId: 7,
      },
      {
        facetId: 1358,
        levelId: 7,
      },
    ],
    sports: [
      {
        facetId: 1732,
        levelId: 9,
      },
      {
        facetId: 1755,
        levelId: 9,
      },
      {
        facetId: 1900,
        levelId: 9,
      },
      {
        facetId: 1746,
        levelId: 9,
      },
      {
        facetId: 1773,
        levelId: 9,
      },
      {
        facetId: 1812,
        levelId: 10,
      },
      {
        facetId: 1801,
        levelId: 9,
      },
      {
        facetId: 1733,
        levelId: 9,
      },
      {
        facetId: 1730,
        levelId: 9,
      },
      {
        facetId: 1775,
        levelId: 9,
      },
    ],
    presenting: [
      {
        facetId: 1986,
        levelId: 11,
      },
    ],
    measurements: [
      {
        measurementType: "Chest",
        value: 101.6,
      },
      {
        measurementType: "Waist",
        value: 81.3,
      },
      {
        measurementType: "Hips",
        value: 96.5,
      },
      {
        measurementType: "InsideLeg",
        value: 78.7,
      },
      {
        measurementType: "Collar",
        value: 38.1,
      },
      {
        measurementType: "Shoes",
        value: 11,
      },
      {
        measurementType: "Height",
        value: 180,
      },
      {
        measurementType: "Weight",
        value: 69.9,
      },
    ],
    credits: [
      {
        typeId: 52,
        role: "Marco",
        name: "The Xit: Episode 2 - The Delivery",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "",
        director: "Joe Archer",
        highlighted: false,
        position: 9,
      },
      {
        typeId: 8,
        role: "Alec",
        name: "Quest for the Grailey Hole",
        dateTo: "2018-12-31T00:00:00+00:00",
        company: "Queen Margaret University",
        venue: "",
        director: "",
        highlighted: false,
        position: 9,
      },
      {
        typeId: 4,
        role: "Male Customer",
        name: "Create Interiors Showroom",
        dateTo: "2017-12-31T00:00:00+00:00",
        company: "Connected Influence",
        venue: "",
        director: "",
        highlighted: false,
        position: 4,
      },
      {
        typeId: 4,
        role: "Band Member",
        name: "Tommy Hilfiger Fragrance",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Tommy Hilfiger",
        director: "Matt Baron",
        highlighted: false,
        position: 3,
      },
      {
        typeId: 8,
        role: "Mark",
        name: "Alba",
        dateTo: "2020-01-01T00:00:00+00:00",
        company: "",
        director: "Margherita Mazza",
        highlighted: false,
        position: 1,
      },
      {
        typeId: 3,
        role: "Tortured Homeowner",
        name: "Redwood Massacre: Annihilation",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Clear Focus Pictures",
        director: "David Ryan Kieth ",
        highlighted: false,
        position: 0,
      },
      {
        typeId: 23,
        role: "Sorcerer",
        name: "Motion Capture Sorcerer Movements",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Awesome Dog Animations",
        director: "Jim Clark",
        highlighted: false,
        position: 5,
      },
      {
        typeId: 4,
        role: "Builder 2",
        name: "On The Tools: Bosch Laser Level",
        dateTo: "2020-12-31T00:00:00+00:00",
        company: "Electric House",
        venue: "",
        director: "Mary McCarthy",
        highlighted: false,
        position: 0,
      },
      {
        typeId: 4,
        role: "Red Ranger",
        name: "Power Rangers Morphsuit",
        dateTo: "2017-12-31T00:00:00+00:00",
        company: "Morphcostumes",
        venue: "",
        director: "",
        highlighted: false,
        position: 5,
      },
      {
        typeId: 12,
        role: "Fight Choreographer",
        name: "The Zara Effect",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "",
        director: "Lewis Cox",
        highlighted: false,
        position: 1,
      },
      {
        typeId: 10,
        role: "Hero",
        name: "Seafret: Fall",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "",
        director: "Stuart Breadner",
        highlighted: false,
        position: 6,
      },
      {
        typeId: 4,
        role: "Spiderman",
        name: "Spiderman Homecoming Morphsuit",
        dateTo: "2017-12-31T00:00:00+00:00",
        company: "Morphcostumes",
        venue: "",
        director: "",
        highlighted: false,
        position: 6,
      },
      {
        typeId: 8,
        role: "Michael",
        name: "I Am God",
        dateTo: "2018-12-31T00:00:00+00:00",
        company: "",
        venue: "",
        director: "Madalina Mateciuc",
        highlighted: false,
        position: 8,
      },
      {
        typeId: 0,
        role: "Acrobat",
        name: "Cabaret Noir",
        dateTo: "2020-01-01T00:00:00+00:00",
        company: "Party Like Gatsby",
        director: "Julie Moonlee",
        highlighted: false,
        position: 2,
      },
      {
        typeId: 17,
        role: "Narrator",
        name: "Obscura",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "",
        director: "Jay Seymour",
        highlighted: false,
        position: 10,
      },
      {
        typeId: 10,
        role: "Soaked man",
        name: "Good Girls Do Bad Things",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Lucia & the Best Boys",
        director: "Stuart Breadner",
        highlighted: false,
        position: 7,
      },
      {
        typeId: 8,
        role: "Gavin",
        name: "Karen",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "",
        director: "Ross Stewart",
        highlighted: false,
        position: 3,
      },
      {
        typeId: 8,
        role: "Luke",
        name: "Job-It",
        dateTo: "2018-12-31T00:00:00+00:00",
        company: "The National Youth Film Academy",
        venue: "",
        director: "Joe Archer",
        highlighted: false,
        position: 6,
      },
      {
        typeId: 8,
        role: "Sandy",
        name: "Existence",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "",
        director: "Euan Brown",
        highlighted: false,
        position: 5,
      },
      {
        typeId: 0,
        role: "Performer",
        name: "On Edge",
        dateTo: "2021-12-31T00:00:00+00:00",
        company: "Justice In Motion",
        venue: "",
        director: "Anja Meinhardt",
        highlighted: false,
        position: 0,
      },
      {
        typeId: 35,
        role: "Waiter",
        name: "Last Date",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Omni Productions",
        director: "Rich Penfold",
        highlighted: false,
        position: 8,
      },
      {
        typeId: 4,
        role: "Spiderman",
        name: "Avengers Montage Morphsuit",
        dateTo: "2017-12-31T00:00:00+00:00",
        company: "Morphcostumes",
        venue: "",
        director: "",
        highlighted: false,
        position: 7,
      },
      {
        typeId: 3,
        role: "Jensen",
        name: "The Blindman",
        dateTo: "2020-01-01T00:00:00+00:00",
        company: "",
        director: "Rowan Coleman",
        highlighted: false,
        position: 1,
      },
      {
        typeId: 1,
        role: "Ghostly Circus Worker",
        name: "Hometown Horror: Three-Ring Terror",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "",
        director: "Elliot Goldner",
        highlighted: false,
        position: 0,
      },
      {
        typeId: 8,
        role: "Charlie",
        name: "To Tango",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "",
        director: "Lewis Cox",
        highlighted: false,
        position: 4,
      },
      {
        typeId: 8,
        role: "Viking + Fight Choreographer",
        name: "Solvi",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "The National Youth Film Academy",
        director: "Joe Archer",
        highlighted: false,
        position: 2,
      },
      {
        typeId: 8,
        role: "Nick",
        name: "Emergency Love",
        dateTo: "2018-12-31T00:00:00+00:00",
        company: "",
        venue: "",
        director: "Krisztián Kiss",
        highlighted: false,
        position: 7,
      },
      {
        typeId: 4,
        role: "Son",
        name: "Fordpass App",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Content Haus",
        director: "Mark Roylance",
        highlighted: false,
        position: 1,
      },
      {
        typeId: 23,
        role: "Ninja",
        name: "Motion Capture Ninja Movements",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Awesome Dog Animations",
        director: "Jim Clark",
        highlighted: false,
        position: 4,
      },
      {
        typeId: 0,
        role: "Reverend Green",
        name: "Clue-Done it",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Circus Alba",
        director: "Suzanne Enoch",
        highlighted: false,
        position: 3,
      },
      {
        typeId: 4,
        role: "Model",
        name: "New Balance Celtic FC",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Fresh Base Productions",
        director: "Guarav Kumar",
        highlighted: false,
        position: 2,
      },
      {
        typeId: 8,
        role: "Leo",
        name: "Rottweiler",
        dateTo: "2020-01-01T00:00:00+00:00",
        company: "The National Youth Film Academy",
        director: "John Powell",
        highlighted: false,
        position: 0,
      },
    ],
    creditHeadings: [
      {
        orderByDate: false,
        isHidden: true,
        position: 8,
        creditType: {
          id: 0,
          name: "Stage",
          hasVenue: true,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 3,
        creditType: {
          id: 1,
          name: "Television",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 2,
        creditType: {
          id: 3,
          name: "Feature Film",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 1,
        creditType: {
          id: 4,
          name: "Commercial",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 0,
        creditType: {
          id: 8,
          name: "Short Film",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 7,
        creditType: {
          id: 10,
          name: "Music Video",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 6,
        creditType: {
          id: 12,
          name: "Film",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 4,
        creditType: {
          id: 17,
          name: "Documentary",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 9,
        creditType: {
          id: 23,
          name: "Video Game",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 5,
        creditType: {
          id: 35,
          name: "Educational",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 10,
        creditType: {
          id: 52,
          name: "Web Series",
          hasVenue: false,
        },
      },
    ],
    isPregnant: false,
    playingAgeFrom: 18,
    playingAgeTo: 30,
    dateOfBirthUtc: "1995-11-07T00:00:00+00:00",
    height: 180,
    viewPin: "4773-5617-1607",
    isVisibleActualAge: true,
    isVisibleDisability: false,
    isVisibleGender: false,
    isLicenseRequired: false,
  },
  {
    id: "0c1381f0-2963-48ad-a23d-2da1887b4739",
    artistRef: "M190764",
    mainPhoto: {
      id: "40e47452-c7c7-4fc0-baa0-851cd6a49385",
      fileName: "M00190764-0108",
      description: "",
      photographer: {
        name: "Wolf Marloh",
      },
    },
    galleryPhotos: [
      {
        position: 5,
        isHidden: true,
        id: "d2e04f51-14ba-4a71-a908-3f82d742e1ce",
        fileName: "M00190764-01",
        photographer: {
          name: "Darren Bell",
        },
      },
      {
        position: 2,
        isHidden: false,
        id: "e27a1d7a-2a7c-4ebc-9545-7c3d9ca61fe1",
        fileName: "M00190764-0109",
        description: "",
        photographer: {
          name: "Wolf Marloh",
        },
      },
      {
        position: 3,
        isHidden: false,
        id: "cdb97f40-e502-490d-91ee-8dd0adafc416",
        fileName: "M00190764-0110",
        description: "",
        photographer: {
          name: "Wolf Marloh",
        },
      },
      {
        position: 1,
        isHidden: false,
        id: "bc2054b7-0c65-4a5c-b694-9d7ac7b3f0e9",
        fileName: "M00190764-0106",
        description: "",
        photographer: {
          name: "Wolf Marloh",
        },
      },
      {
        position: 4,
        isHidden: true,
        id: "2ce9711f-8dc9-49da-a7a3-bb8f2d2147f8",
        fileName: "M00190764-0101",
        description: "",
        photographer: {
          name: "Nick James",
        },
      },
      {
        position: 6,
        isHidden: true,
        id: "ca706ffe-b24c-4c46-b52c-ed120d6cee6d",
        fileName: "M00190764-0104",
        description: "",
        photographer: {
          name: "Darren Bell",
        },
      },
    ],
    forename: "LUKE",
    surname: "BAVERSTOCK",
    performerType: "Performer",
    publicationCode: 1,
    contract: {
      membership: "performerfamily",
      status: "current",
      expirationDate: "2020-05-12T00:00:00+00:00",
    },
    mainAgent: {
      agentRef: 50,
      name: "SPOTLIGHT",
      email: "enquiries@spotlight.com",
      phone: "020 7437 7631",
      mobilePhone: "020 7437 7631",
      website: "www.spotlight.com",
      address: {
        id: 111,
        addressLine1: "Spotlight",
        addressLine2: "7 Leicester Place",
        addressLine3: "London",
        addressLine4: "",
        country: "",
        postCode: "WC2H 7RJ",
      },
    },
    agents: [
      {
        agentRef: 50,
        name: "SPOTLIGHT",
        email: "enquiries@spotlight.com",
        phone: "020 7437 7631",
        mobilePhone: "020 7437 7631",
        website: "www.spotlight.com",
        address: {
          id: 111,
          addressLine1: "Spotlight",
          addressLine2: "7 Leicester Place",
          addressLine3: "London",
          addressLine4: "",
          country: "",
          postCode: "WC2H 7RJ",
        },
      },
    ],
    dramaSchools: [],
    showreelsCount: 0,
    audioclipsCount: 0,
    locations: [],
    castingDirectorNotes: [],
    gender: [5203],
    disabilities: [],
    nationalities: [],
    appearances: [1716],
    eyeColours: [246],
    facialHairs: [],
    hairColours: [266],
    hairLength: [277],
    beltNotes: [],
    accentsAndDialects: [
      {
        facetId: 166,
        levelId: 1,
      },
      {
        facetId: 69,
        levelId: 1,
      },
      {
        facetId: 47,
        levelId: 1,
      },
      {
        facetId: 44,
        levelId: 1,
      },
      {
        facetId: 70,
        levelId: 1,
      },
      {
        facetId: 5,
        levelId: 1,
      },
      {
        facetId: 12,
        levelId: 1,
      },
      {
        facetId: 49,
        levelId: 1,
      },
      {
        facetId: 43,
        levelId: 1,
      },
      {
        facetId: 38,
        levelId: 2,
      },
    ],
    vehicleLicences: [],
    languages: [],
    musicAndDance: [
      {
        facetId: 608,
        levelId: 5,
      },
      {
        facetId: 694,
        levelId: 5,
      },
      {
        facetId: 797,
        levelId: 6,
      },
      {
        facetId: 600,
        levelId: 5,
      },
      {
        facetId: 591,
        levelId: 5,
      },
      {
        facetId: 582,
        levelId: 5,
      },
      {
        facetId: 749,
        levelId: 5,
      },
      {
        facetId: 619,
        levelId: 6,
      },
    ],
    otherSkills: [],
    performances: [],
    sports: [],
    presenting: [],
    measurements: [
      {
        measurementType: "Weight",
        value: 78.47,
      },
      {
        measurementType: "UpperVocalNote",
        value: 47,
      },
      {
        measurementType: "LowerVocalNote",
        value: 20,
      },
      {
        measurementType: "Height",
        value: 180,
      },
    ],
    credits: [
      {
        typeId: 8,
        role: "Owen",
        name: "In Living Memory",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "Lion Child Productions",
        director: "Lee Khan",
        highlighted: false,
        position: 6,
      },
      {
        typeId: 8,
        role: "Jake",
        name: "Alone Together",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "MET Film School",
        director: "Richard Taylor",
        highlighted: false,
        position: 10,
      },
      {
        typeId: 8,
        role: "Curtis",
        name: "Ye Who Enter Here",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "Ravensbourne University",
        director: "Billy Dudley",
        highlighted: false,
        position: 4,
      },
      {
        typeId: 8,
        role: "Rupert",
        name: "Yolk",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "Nedu Kay",
        director: "Nedu Nwankpa",
        highlighted: false,
        position: 8,
      },
      {
        typeId: 13,
        role: "Hanschen",
        name: "Spring Awakening",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "Major Productions",
        director: "Laura Checkley",
        highlighted: false,
        position: 11,
      },
      {
        typeId: 8,
        role: "Charlie",
        name: "Earthy Encounters",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "Forty Foot Pictures Ltd.",
        director: "Sam Johnson",
        highlighted: false,
        position: 5,
      },
      {
        typeId: 8,
        role: "Jake",
        name: "Send Location",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "MMCD Studio",
        director: "Michael McDonough",
        highlighted: false,
        position: 9,
      },
      {
        typeId: 8,
        role: "Greg",
        name: "Turning Pointe",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "Stardanced Productions",
        director: "Xenia Swan",
        highlighted: false,
        position: 7,
      },
      {
        typeId: 13,
        role: "Tateh",
        name: "Ragtime",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "The Urdang Academy",
        director: "Hannah Chissick",
        highlighted: false,
        position: 13,
      },
      {
        typeId: 8,
        role: "Griff",
        name: "Good Morning",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "Moonchild Productions",
        director: "Callum O'Brien",
        highlighted: false,
        position: 3,
      },
      {
        typeId: 26,
        role: "Luke",
        name: "Some Words",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "P2ST Creative Limited",
        director: "Michael Strassen",
        highlighted: false,
        position: 12,
      },
      {
        typeId: 0,
        role: "Georgie",
        name: "A Clockwork Orange",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "Park Theatre",
        director: "Alexandra Spencer-Jones",
        highlighted: false,
        position: 2,
      },
      {
        typeId: 8,
        role: "Oliver Berry",
        name: "Milk Before Meat",
        dateTo: "2018-01-01T00:00:00+00:00",
        company: "Ravensbourne",
        director: "Amber Cherry",
        highlighted: false,
        position: 1,
      },
    ],
    creditHeadings: [
      {
        orderByDate: false,
        isHidden: true,
        position: 2,
        creditType: {
          id: 0,
          name: "Stage",
          hasVenue: true,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 1,
        creditType: {
          id: 8,
          name: "Short Film",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 0,
        creditType: {
          id: 13,
          name: "Musical",
          hasVenue: true,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 3,
        creditType: {
          id: 26,
          name: "Workshop",
          hasVenue: false,
        },
      },
    ],
    isPregnant: false,
    playingAgeFrom: 17,
    playingAgeTo: 25,
    dateOfBirthUtc: "1993-09-07T00:00:00+00:00",
    height: 180,
    viewPin: "9251-0166-3052",
    isVisibleActualAge: false,
    isVisibleDisability: false,
    isVisibleGender: false,
  },
  {
    id: "5bb48aaf-ae8b-4ae8-8b22-7ad7c6243f55",
    artistRef: "M127443",
    mainPhoto: {
      id: "d5250f5b-89ab-4cf8-bf28-7d1f6e0194ab",
      fileName: "M00127443-0110",
      description: "",
      photographer: {
        name: "Paul Smith",
      },
    },
    galleryPhotos: [
      {
        position: 6,
        isHidden: true,
        id: "09b77801-027d-470f-8ae1-14f13b95db71",
        fileName: "M00127443-0104",
        description: "",
        photographer: {
          name: "Paul Smith",
        },
      },
      {
        position: 3,
        isHidden: false,
        id: "2db07b44-395f-42f0-a2cd-21caabd0fb1a",
        fileName: "M00127443-0111",
        description: "",
        photographer: {
          name: "Paul Smith",
        },
      },
      {
        position: 0,
        isHidden: false,
        id: "ab22dd52-4753-4039-ac71-81fbd7c69c66",
        fileName: "M00127443-0113",
        description: "",
        photographer: {
          name: "Paul Smith",
        },
      },
      {
        position: 5,
        isHidden: true,
        id: "86f02c97-f509-43f5-9221-8ff89aa198d9",
        fileName: "M00127443-01",
        photographer: {
          name: "Paul Smith",
        },
      },
      {
        position: 4,
        isHidden: false,
        id: "ecf1361d-b4cc-4782-9547-a54834747c21",
        fileName: "M00127443-0114",
        description: "",
        photographer: {
          name: "Paul Smith",
        },
      },
      {
        position: 2,
        isHidden: false,
        id: "177ebe8a-c355-4238-8a38-d92baee16248",
        fileName: "M00127443-0109",
        description: "",
        photographer: {
          name: "Paul Smith",
        },
      },
      {
        position: 1,
        isHidden: false,
        id: "2d01f459-8c04-4642-997e-e7a66e7e25d7",
        fileName: "M00127443-0112",
        description: "",
        photographer: {
          name: "Paul Smith",
        },
      },
    ],
    forename: "LUKE",
    surname: "BEATTIE",
    performerType: "Performer",
    publicationCode: 1,
    contract: {
      membership: "performerfamily",
      status: "current",
      expirationDate: "2020-05-12T00:00:00+00:00",
    },
    mainAgent: {
      agentRef: 10848,
      name: "BOLAND & REEVE",
      email: "enquiries@spotlight.com",
      phone: "020 7437 7631",
      mobilePhone: "020 7437 7631",
      website: "www.spotlight.com",
      address: {
        id: 111,
        addressLine1: "Spotlight",
        addressLine2: "7 Leicester Place",
        addressLine3: "London",
        addressLine4: "",
        country: "",
        postCode: "WC2H 7RJ",
      },
    },
    agents: [
      {
        agentRef: 10848,
        name: "BOLAND & REEVE",
        email: "enquiries@spotlight.com",
        phone: "020 7437 7631",
        mobilePhone: "020 7437 7631",
        website: "www.spotlight.com",
        address: {
          id: 111,
          addressLine1: "Spotlight",
          addressLine2: "7 Leicester Place",
          addressLine3: "London",
          addressLine4: "",
          country: "",
          postCode: "WC2H 7RJ",
        },
      },
    ],
    dramaSchools: [],
    showreelsCount: 2,
    audioclipsCount: 5,
    locations: [],
    castingDirectorNotes: [],
    gender: [5203],
    disabilities: [],
    nationalities: [],
    appearances: [1716],
    eyeColours: [246],
    facialHairs: [],
    hairColours: [262],
    hairLength: [277],
    beltNotes: [],
    accentsAndDialects: [
      {
        facetId: 144,
        levelId: 2,
      },
      {
        facetId: 40,
        levelId: 1,
      },
      {
        facetId: 64,
        levelId: 2,
      },
      {
        facetId: 38,
        levelId: 2,
      },
      {
        facetId: 156,
        levelId: 1,
      },
      {
        facetId: 116,
        levelId: 1,
      },
      {
        facetId: 162,
        levelId: 1,
      },
      {
        facetId: 43,
        levelId: 1,
      },
      {
        facetId: 166,
        levelId: 1,
      },
      {
        facetId: 44,
        levelId: 1,
      },
    ],
    vehicleLicences: [
      {
        facetId: 225,
      },
    ],
    languages: [
      {
        facetId: 294,
        levelId: 4,
      },
    ],
    musicAndDance: [
      {
        facetId: 592,
        levelId: 5,
      },
      {
        facetId: 619,
        levelId: 5,
      },
    ],
    otherSkills: [
      {
        facetId: 913,
      },
      {
        facetId: 935,
      },
      {
        facetId: 1113,
      },
      {
        facetId: 901,
      },
      {
        facetId: 954,
      },
      {
        facetId: 1129,
      },
      {
        facetId: 891,
      },
      {
        facetId: 1083,
      },
      {
        facetId: 946,
      },
      {
        facetId: 999,
      },
      {
        facetId: 1027,
      },
      {
        facetId: 998,
      },
      {
        facetId: 1010,
      },
      {
        facetId: 885,
      },
      {
        facetId: 1171,
      },
      {
        facetId: 921,
      },
      {
        facetId: 900,
      },
      {
        facetId: 974,
      },
      {
        facetId: 1044,
      },
      {
        facetId: 884,
      },
      {
        facetId: 922,
      },
    ],
    performances: [
      {
        facetId: 1330,
        levelId: 7,
      },
      {
        facetId: 1529,
        levelId: 7,
      },
      {
        facetId: 1422,
        levelId: 7,
      },
      {
        facetId: 1317,
        levelId: 7,
      },
      {
        facetId: 1431,
        levelId: 7,
      },
      {
        facetId: 1361,
        levelId: 7,
      },
      {
        facetId: 1345,
        levelId: 7,
      },
      {
        facetId: 1342,
        levelId: 7,
      },
      {
        facetId: 1324,
        levelId: 7,
      },
      {
        facetId: 1327,
        levelId: 7,
      },
      {
        facetId: 1365,
        levelId: 7,
      },
      {
        facetId: 1340,
        levelId: 7,
      },
      {
        facetId: 1332,
        levelId: 7,
      },
      {
        facetId: 1412,
        levelId: 7,
      },
      {
        facetId: 1424,
        levelId: 7,
      },
      {
        facetId: 1435,
        levelId: 7,
      },
      {
        facetId: 1343,
        levelId: 7,
      },
      {
        facetId: 1319,
        levelId: 7,
      },
      {
        facetId: 1329,
        levelId: 7,
      },
      {
        facetId: 1380,
        levelId: 7,
      },
      {
        facetId: 1346,
        levelId: 7,
      },
      {
        facetId: 1320,
        levelId: 7,
      },
      {
        facetId: 1344,
        levelId: 7,
      },
      {
        facetId: 1419,
        levelId: 7,
      },
      {
        facetId: 1373,
        levelId: 7,
      },
      {
        facetId: 1313,
        levelId: 7,
      },
      {
        facetId: 1524,
        levelId: 7,
      },
      {
        facetId: 1337,
        levelId: 7,
      },
      {
        facetId: 1370,
        levelId: 7,
      },
    ],
    sports: [
      {
        facetId: 1767,
        levelId: 10,
      },
      {
        facetId: 1808,
        levelId: 9,
      },
      {
        facetId: 1755,
        levelId: 10,
      },
      {
        facetId: 1774,
        levelId: 9,
      },
      {
        facetId: 1923,
        levelId: 9,
      },
      {
        facetId: 1763,
        levelId: 10,
      },
      {
        facetId: 1771,
        levelId: 9,
      },
      {
        facetId: 1742,
        levelId: 9,
      },
      {
        facetId: 1780,
        levelId: 10,
      },
      {
        facetId: 1750,
        levelId: 9,
      },
    ],
    presenting: [],
    measurements: [
      {
        measurementType: "Weight",
        value: 72.57,
      },
      {
        measurementType: "Height",
        value: 177,
      },
    ],
    credits: [
      {
        typeId: 0,
        role: "Son",
        name: "Bully",
        dateTo: "2002-01-01T00:00:00+00:00",
        company: "Telus Studio Theatre",
        director: "Kelly Straughan",
        highlighted: false,
        position: 51,
      },
      {
        typeId: 12,
        role: "Soap Actor",
        name: "The Zoo Project",
        dateTo: "2004-01-01T00:00:00+00:00",
        company: "Awake Films",
        director: "Chris Ruffatto",
        highlighted: false,
        position: 64,
      },
      {
        typeId: 6,
        role: "Lead",
        name: "Conundroom Express",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "Conundroom",
        director: "Luke Beattie",
        highlighted: false,
        position: 18,
      },
      {
        typeId: 0,
        role: "Master of the Ship/Reaper",
        name: "The Tempest",
        dateTo: "2008-01-01T00:00:00+00:00",
        company: "Roborough Studios",
        director: "Luke Beattie",
        highlighted: false,
        position: 39,
      },
      {
        typeId: 1,
        role: "Sport Commentator",
        name: "Rosamunde Pilcher (episode: Guardian Angel)",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "FFP New Media/ZDF",
        director: "Stefan Bartmann",
        highlighted: false,
        position: 4,
      },
      {
        typeId: 6,
        role: "Narrator (Canadian)",
        name: "RSA Boardroom viral commercial",
        dateTo: "2013-01-01T00:00:00+00:00",
        company: "Twangling",
        director: "Mike Hill",
        highlighted: false,
        position: 20,
      },
      {
        typeId: 6,
        role: "Narrator (Canadian)",
        name: "RSA Gamer viral commercial",
        dateTo: "2013-01-01T00:00:00+00:00",
        company: "Twangling",
        director: "Mike Hill",
        highlighted: false,
        position: 21,
      },
      {
        typeId: 0,
        role: "Lord Mortimer/First Carrier",
        name: "Henry IV part I",
        dateTo: "2004-01-01T00:00:00+00:00",
        company: "Savage God",
        director: "Anna Hagan",
        highlighted: false,
        position: 47,
      },
      {
        typeId: 6,
        role: "Lead",
        name: "DOTA2 Shakespeare Announcer Demo",
        dateTo: "2012-01-01T00:00:00+00:00",
        company: "Steam Workshop",
        director: "Matt Boone",
        highlighted: false,
        position: 25,
      },
      {
        typeId: 0,
        role: "McCue",
        name: "The Front Page",
        dateTo: "2005-01-01T00:00:00+00:00",
        company: "Ensemble Theatre Company",
        director: "Tariq Leslie",
        highlighted: false,
        position: 46,
      },
      {
        typeId: 1,
        role: "Middle-Aged Man",
        name: "Pennyworth (episode 201)",
        dateTo: "2020-01-01T00:00:00+00:00",
        company: "Warner Horizon Television",
        director: "Danny Cannon",
        highlighted: false,
        position: 3,
      },
      {
        typeId: 0,
        role: "Mr. Shanks",
        name: "Habeas Corpus",
        dateTo: "2013-01-01T00:00:00+00:00",
        company: "Western Gold Theatre Society",
        director: "Anna Hagan",
        highlighted: false,
        position: 35,
      },
      {
        typeId: 0,
        role: "Baron Tuzenbach",
        name: "Three Sisters",
        dateTo: "2000-01-01T00:00:00+00:00",
        company: "Frederic Wood Theatre",
        director: "Kathleen Weiss",
        highlighted: false,
        position: 57,
      },
      {
        typeId: 4,
        role: "Maintenance Officer",
        name: "Caverion Space Saga: Energy Efficiency",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "Bob the Robot Pictures",
        director: "Jaakko Itäaho",
        highlighted: false,
        position: 9,
      },
      {
        typeId: 6,
        role: "Macduff/Ross",
        name: "Macbeth",
        dateTo: "2008-01-01T00:00:00+00:00",
        company: "The Shakespeare Light Radio Co",
        director: "Luke Beattie",
        highlighted: false,
        position: 26,
      },
      {
        typeId: 3,
        role: "Agent",
        name: "Provenance",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "White Horse Films",
        director: "Christian McKay/Ben Hecking",
        highlighted: false,
        position: 61,
      },
      {
        typeId: 6,
        role: "Lead",
        name: "An Inconceivable Evening with Cary Elwes (event promo)",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "Midland Center for the Arts (Michigan)",
        director: "Luke Beattie",
        highlighted: false,
        position: 14,
      },
      {
        typeId: 6,
        role: "Narrator",
        name: "Just Eat (online commercial)",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "Michael Ferns Films",
        director: "Michael J. Ferns",
        highlighted: false,
        position: 16,
      },
      {
        typeId: 0,
        role: "Lieutenant/Sergeant",
        name: "We Won't Pay! We Won't Pay!",
        dateTo: "2003-01-01T00:00:00+00:00",
        company: "Springboard Productions",
        director: "Marek Czuma",
        highlighted: false,
        position: 49,
      },
      {
        typeId: 12,
        role: "Marco",
        name: "Gordon",
        dateTo: "2003-01-01T00:00:00+00:00",
        company: "Oak Seed Entertainment",
        director: "Timothy Aikman",
        highlighted: false,
        position: 65,
      },
      {
        typeId: 6,
        role: "Lead Role",
        name: "Wild Planet Air Boom Box Promo",
        dateTo: "2005-01-01T00:00:00+00:00",
        company: "Cowie and Fox",
        director: "Noel Fox",
        highlighted: false,
        position: 29,
      },
      {
        typeId: 12,
        role: "Recruit Luke",
        name: "Short Film Boot Camp",
        dateTo: "2005-01-01T00:00:00+00:00",
        company: "Crazy8s Film",
        director: "Kaare Andrews",
        highlighted: false,
        position: 63,
      },
      {
        typeId: 0,
        role: "David/Chorus",
        name: "J.B.",
        dateTo: "2006-01-01T00:00:00+00:00",
        company: "West End Productions",
        director: "Anna Hagan",
        highlighted: false,
        position: 45,
      },
      {
        typeId: 0,
        role: "Lord/Messenger",
        name: "Macbeth",
        dateTo: "1998-01-01T00:00:00+00:00",
        company: "Frederic Wood Theatre",
        director: "Stephen Malloy",
        highlighted: false,
        position: 60,
      },
      {
        typeId: 6,
        role: "Narrator (Canadian)",
        name: "RSA Golfer viral commercial",
        dateTo: "2013-01-01T00:00:00+00:00",
        company: "Twangling",
        director: "Mike Hill",
        highlighted: false,
        position: 23,
      },
      {
        typeId: 4,
        role: "Maintenance Officer",
        name: "Caverion Space Saga: Indoor Climate",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "Bob the Robot Pictures",
        director: "Jaakko Itäaho",
        highlighted: false,
        position: 10,
      },
      {
        typeId: 1,
        role: "Colleague",
        name: "50 Ways to Kill Your Lover (episode: Murder Mystery)",
        dateTo: "2013-01-01T00:00:00+00:00",
        company: "Thumbs Up Productions",
        director: "Jeremy Freeston",
        highlighted: false,
        position: 6,
      },
      {
        typeId: 6,
        role: "Lead (Commentator/Umpire)",
        name: "Fantasy Basebrawl online game",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "Red Shade Games",
        director: "Luke Beattie",
        highlighted: false,
        position: 19,
      },
      {
        typeId: 0,
        role: "Will/Neighbour Daddy",
        name: "Love Song in Iambic Pentameter",
        dateTo: "2007-01-01T00:00:00+00:00",
        company: "Edinburgh Fringe",
        director: "Ina Li",
        highlighted: false,
        position: 40,
      },
      {
        typeId: 0,
        role: "Antipholus of Syracuse/Jailer",
        name: "The Comedy of Errors",
        dateTo: "2007-01-01T00:00:00+00:00",
        company: "Roborough Studios",
        director: "Christopher McCullough",
        highlighted: false,
        position: 41,
      },
      {
        typeId: 4,
        role: "Maintenance Officer",
        name: "Caverion Space Saga: Infrastructure",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "Bob the Robot Pictures",
        director: "Jaakko Itäaho",
        highlighted: false,
        position: 11,
      },
      {
        typeId: 6,
        role: "Lead Role",
        name: "Zeebuzz telephone vocal ring tones",
        dateTo: "2005-01-01T00:00:00+00:00",
        company: "29 Productions",
        director: "Micah Groberman",
        highlighted: false,
        position: 30,
      },
      {
        typeId: 0,
        role: "Barnette Lloyd",
        name: "Crimes of the Heart",
        dateTo: "1999-01-01T00:00:00+00:00",
        company: "Frederic Wood Theatre",
        director: "Gregory Berry",
        highlighted: false,
        position: 58,
      },
      {
        typeId: 0,
        role: "Tobacco/Bathsheba",
        name: "The Petworth Plays",
        dateTo: "2014-01-01T00:00:00+00:00",
        company: "Hotspur Theatre/The Petworth Festival",
        director: "Tam Williams",
        highlighted: false,
        position: 34,
      },
      {
        typeId: 18,
        role: "Model",
        name: "VanCity Accessibility print commercial",
        dateTo: "2004-01-01T00:00:00+00:00",
        company: "Grey Worldwide Northwest",
        director: "Larry Goldstein",
        highlighted: false,
        position: 2,
      },
      {
        typeId: 6,
        role: "Lead",
        name: "Zervant E-Invoicing (explainer video)",
        dateTo: "2018-01-01T00:00:00+00:00",
        company: "Spoon Agency",
        director: "Jukka Hurme",
        highlighted: false,
        position: 13,
      },
      {
        typeId: 6,
        role: "Radio DJ/Police Officer 7",
        name: "The Inpatient (video game)",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "Supermassive Games",
        director: "Shepperton Studios",
        highlighted: false,
        position: 17,
      },
      {
        typeId: 0,
        role: "Sir John Falstaff",
        name: "The Merry Wives of Windsor",
        dateTo: "2007-01-01T00:00:00+00:00",
        company: "Roborough Studios",
        director: "Parker Reed",
        highlighted: false,
        position: 42,
      },
      {
        typeId: 0,
        role: "Gilbert Blythe",
        name: "Anne",
        dateTo: "2001-01-01T00:00:00+00:00",
        company: "Carousel Theatre for Young People",
        director: "Chris McGregor",
        highlighted: false,
        position: 53,
      },
      {
        typeId: 0,
        role: "Pip/Nathaniel Winkle",
        name: "The Trials of Charles Dickens",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "The Dickens Theatre Company of Medway",
        director: "Eric Richard",
        highlighted: false,
        position: 32,
      },
      {
        typeId: 6,
        role: "Emcee",
        name: "Desert Lores fashion show",
        dateTo: "2005-01-01T00:00:00+00:00",
        company: "Vancouver Fashion Week",
        director: "Niti Maini",
        highlighted: false,
        position: 28,
      },
      {
        typeId: 0,
        role: "Lysimachus/First Knight",
        name: "Pericles, Prince of Tyre",
        dateTo: "2008-01-01T00:00:00+00:00",
        company: "Vanguard Theatre/RSC at the Dell/Roborough",
        director: "Luke Beattie",
        highlighted: false,
        position: 38,
      },
      {
        typeId: 6,
        role: "Narrator (Canadian)",
        name: "RSA Long Time No Speak viral commercial",
        dateTo: "2013-01-01T00:00:00+00:00",
        company: "Twangling",
        director: "Mike Hill",
        highlighted: false,
        position: 24,
      },
      {
        typeId: 0,
        role: "Chorus",
        name: "The Bacchae",
        dateTo: "1999-01-01T00:00:00+00:00",
        company: "Frederic Wood Theatre",
        director: "Kelly-Ruth Mercier",
        highlighted: false,
        position: 59,
      },
      {
        typeId: 4,
        role: "Fire Hero",
        name: "Media Markt: Men's Monthlies",
        dateTo: "2018-01-01T00:00:00+00:00",
        company: "Stink Films",
        director: "Sam Larsson",
        highlighted: false,
        position: 8,
      },
      {
        typeId: 0,
        role: "Uriah Shelley",
        name: "The Elephant Calf",
        dateTo: "2001-01-01T00:00:00+00:00",
        company: "Telus Studio Theatre",
        director: "Stephen Drover",
        highlighted: false,
        position: 55,
      },
      {
        typeId: 0,
        role: "DeLacey",
        name: "Frankenstein",
        dateTo: "2000-01-01T00:00:00+00:00",
        company: "Frederic Wood Theatre",
        director: "Stephen Malloy",
        highlighted: false,
        position: 56,
      },
      {
        typeId: 0,
        role: "J",
        name: "The Road, The House, The Road",
        dateTo: "2009-01-01T00:00:00+00:00",
        company: "21 for 21 Howard Barker Festival",
        director: "Sophie Hickman",
        highlighted: false,
        position: 37,
      },
      {
        typeId: 12,
        role: "Alien",
        name: "Cultural Differences",
        dateTo: "2005-01-01T00:00:00+00:00",
        company: "Renegade Films",
        director: "Aaron Houston",
        highlighted: false,
        position: 62,
      },
      {
        typeId: 0,
        role: "Old Athenian/Stranger",
        name: "Timon of Athens",
        dateTo: "2007-01-01T00:00:00+00:00",
        company: "Mary Harris Chapel",
        director: "Parker Reed",
        highlighted: false,
        position: 43,
      },
      {
        typeId: 0,
        role: "Marcus Andronicus",
        name: "Titus Andronicus",
        dateTo: "2007-01-01T00:00:00+00:00",
        company: "Thornlea Studios",
        director: "Sarah McCourt",
        highlighted: false,
        position: 44,
      },
      {
        typeId: 6,
        role: "Colin",
        name: "Hangry Bunnies from Mars (video game)",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "Studio229",
        director: "Joel Gerlach",
        highlighted: false,
        position: 15,
      },
      {
        typeId: 0,
        role: "Sir Andrew Aguecheek/Flute",
        name: "Not Half Bard",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "Hotspur Theatre",
        director: "Tam Williams/Nick Malinowski",
        highlighted: false,
        position: 31,
      },
      {
        typeId: 12,
        role: "Crispin",
        name: "The Rooms Disperse",
        dateTo: "2001-01-01T00:00:00+00:00",
        company: "Controlled Souls Filmic",
        director: "Norman Yeung",
        highlighted: false,
        position: 67,
      },
      {
        typeId: 0,
        role: "Henry/Mr Birkbeck",
        name: "Design for Living",
        dateTo: "2002-01-01T00:00:00+00:00",
        company: "Rock-Paper-Scissors",
        director: "Chris McGregor",
        highlighted: false,
        position: 52,
      },
      {
        typeId: 0,
        role: "Duke of Gloucester",
        name: "Henry V",
        dateTo: "2004-01-01T00:00:00+00:00",
        company: "Savage God",
        director: "Anna Hagan",
        highlighted: false,
        position: 48,
      },
      {
        typeId: 7,
        role: "Presenter 2",
        name: "UOB - Knowing Your Customer",
        dateTo: "2014-01-01T00:00:00+00:00",
        company: "Lessons Learned",
        director: "Tim Parkman",
        highlighted: false,
        position: 1,
      },
      {
        typeId: 12,
        role: "Security Guard",
        name: "Waterfall",
        dateTo: "2002-01-01T00:00:00+00:00",
        company: "Paperboy Productions",
        director: "Clifton Prowse",
        highlighted: false,
        position: 66,
      },
      {
        typeId: 1,
        role: "Waiter",
        name: "A Job to Kill For",
        dateTo: "2006-01-01T00:00:00+00:00",
        company: "Front Street Pictures/Lifetime",
        director: "Bill Corcoran",
        highlighted: false,
        position: 7,
      },
      {
        typeId: 0,
        role: "Stan/Klausen",
        name: "Wedgie",
        dateTo: "2003-01-01T00:00:00+00:00",
        company: "Playwrights Theatre Centre",
        director: "Stephen Drover",
        highlighted: false,
        position: 50,
      },
      {
        typeId: 0,
        role: "Matt Thurlowe/Lady Macbeth",
        name: "Dead of Night",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "Hotspur Theatre/Mill at Sonning",
        director: "Chris Myles",
        highlighted: false,
        position: 33,
      },
      {
        typeId: 0,
        role: "Interviewer/Porter",
        name: "Strangers on a Train",
        dateTo: "2013-01-01T00:00:00+00:00",
        company: "Gielgud Theatre, West End",
        director: "Robert Allan Ackerman",
        highlighted: false,
        position: 36,
      },
      {
        typeId: 4,
        role: "Maintenance Officer",
        name: "Caverion Space Saga: Smooth Operations",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "Bob the Robot Pictures",
        director: "Jaakko Itäaho",
        highlighted: false,
        position: 12,
      },
      {
        typeId: 6,
        role: "Narrator (Canadian)",
        name: "RSA Giggs Pizza viral commercial",
        dateTo: "2013-01-01T00:00:00+00:00",
        company: "Twangling",
        director: "Mike Hill",
        highlighted: false,
        position: 22,
      },
      {
        typeId: 0,
        role: "Drake",
        name: "Such a Sweet Thing",
        dateTo: "2001-01-01T00:00:00+00:00",
        company: "Vancouver Fringe/Zealous Minds",
        director: "Zain Meghji",
        highlighted: false,
        position: 54,
      },
      {
        typeId: 6,
        role: "International Presenter/Anchor",
        name: "Xpression News Bulletins",
        dateTo: "2006-01-01T00:00:00+00:00",
        company: "87.7 Xpression FM",
        director: "Bryony Church/Laura Maddrell",
        highlighted: false,
        position: 27,
      },
      {
        typeId: 1,
        role: "Klaus Fuchs",
        name: "Sonya: The Spy who Stole the Atom Bomb",
        dateTo: "2014-01-01T00:00:00+00:00",
        company: "Oxford Digital Media",
        director: "Bill Thomas",
        highlighted: false,
        position: 5,
      },
    ],
    creditHeadings: [
      {
        orderByDate: false,
        isHidden: false,
        position: 3,
        creditType: {
          id: 0,
          name: "Stage",
          hasVenue: true,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 0,
        creditType: {
          id: 1,
          name: "Television",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 6,
        creditType: {
          id: 3,
          name: "Feature Film",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 1,
        creditType: {
          id: 4,
          name: "Commercial",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 2,
        creditType: {
          id: 6,
          name: "Voice Over",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 5,
        creditType: {
          id: 7,
          name: "Corporate",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 4,
        creditType: {
          id: 12,
          name: "Film",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 7,
        creditType: {
          id: 18,
          name: "Still Photography",
          hasVenue: false,
        },
      },
    ],
    isPregnant: false,
    playingAgeFrom: 30,
    playingAgeTo: 40,
    height: 177,
    viewPin: "2455-9055-3734",
    isVisibleActualAge: false,
    isVisibleDisability: false,
    isVisibleGender: false,
    aboutMe:
      'Luke can soon be seen as in "Pennyworth" ep 201 for Warner Horizon Television.\r\n\r\nHe works regularly in voice-over in RP English and West Coast American accents; recent work includes Colin in "Hangry Bunnies from Mars" (https://www.youtube.com/watch?v=iF9jGITqK4E), and the narrator in Zervant\'s e-invoicing explainer video (https://www.youtube.com/watch?v=XvZRkxxzLjI).\r\n',
    training:
      "University of British Columbia (Vancouver) - BA Acting and Directing",
  },
  {
    id: "eaeec68b-50db-4a7a-bf9f-49bce293a178",
    artistRef: "M20552",
    mainPhoto: {
      id: "02b889d5-c84f-4bbf-802e-7cae6a69e84a",
      fileName: "61e39387-6037-4f94-aed0-2e446d57a1ae",
      description: "",
      photographer: {
        name: "Rocco Redondo",
      },
    },
    galleryPhotos: [
      {
        position: 3,
        isHidden: false,
        id: "c0d6a397-6dff-4b9a-a87a-110006fed774",
        fileName: "c07bc7df-8d03-416d-b03e-6e1258e7a50e",
        description: "",
        photographer: {
          name: "Rocco Redondo",
        },
      },
      {
        position: 0,
        isHidden: false,
        id: "106720ef-2484-4c50-af12-545a5de4c32f",
        fileName: "b22cabbe-723c-4214-b8e1-600bb5974220",
        description: "",
        photographer: {
          name: "Rocco Redondo",
        },
      },
      {
        position: 1,
        isHidden: false,
        id: "44381fb0-3bdd-452b-be1f-7294dfa8d34d",
        fileName: "M00020552-0103",
        description: "",
        photographer: {
          name: "Rocco Redondo",
        },
      },
      {
        position: 2,
        isHidden: true,
        id: "1e7436fb-4979-4f82-b524-8ad926f97f63",
        fileName: "M00020552-01",
        photographer: {
          name: "Rocco Redondo",
        },
      },
      {
        position: 4,
        isHidden: false,
        id: "1d7dbb7f-1488-4989-ae2d-968ea7259489",
        fileName: "0f343b59-2f80-40c1-8231-4cca4fc9296f",
        description: "",
        photographer: {
          name: "Rocco Redondo",
        },
      },
    ],
    forename: "LUKE",
    surname: "BRANAGAN",
    performerType: "Performer",
    publicationCode: 1,
    contract: {
      membership: "performerfamily",
      status: "current",
      expirationDate: "2020-05-12T00:00:00+00:00",
    },
    mainAgent: {
      agentRef: 5004,
      name: "CHERRY PARKER MANAGEMENT (RSM)",
      email: "enquiries@spotlight.com",
      phone: "020 7437 7631",
      mobilePhone: "020 7437 7631",
      website: "www.spotlight.com",
      address: {
        id: 111,
        addressLine1: "Spotlight",
        addressLine2: "7 Leicester Place",
        addressLine3: "London",
        addressLine4: "",
        country: "",
        postCode: "WC2H 7RJ",
      },
    },
    agents: [
      {
        agentRef: 5004,
        name: "CHERRY PARKER MANAGEMENT (RSM)",
        email: "enquiries@spotlight.com",
        phone: "020 7437 7631",
        mobilePhone: "020 7437 7631",
        website: "www.spotlight.com",
        address: {
          id: 111,
          addressLine1: "Spotlight",
          addressLine2: "7 Leicester Place",
          addressLine3: "London",
          addressLine4: "",
          country: "",
          postCode: "WC2H 7RJ",
        },
      },
    ],
    dramaSchools: [],
    showreelsCount: 1,
    audioclipsCount: 0,
    locations: [],
    castingDirectorNotes: [],
    gender: [5203],
    disabilities: [],
    nationalities: [],
    appearances: [1716, 1708],
    eyeColours: [248],
    facialHairs: [],
    hairColours: [273],
    hairLength: [278],
    beltNotes: [],
    accentsAndDialects: [
      {
        facetId: 72,
        levelId: 1,
      },
      {
        facetId: 162,
        levelId: 1,
      },
      {
        facetId: 10,
        levelId: 1,
      },
      {
        facetId: 53,
        levelId: 1,
      },
      {
        facetId: 46,
        levelId: 1,
      },
      {
        facetId: 93,
        levelId: 1,
      },
      {
        facetId: 44,
        levelId: 1,
      },
      {
        facetId: 16,
        levelId: 1,
      },
      {
        facetId: 15,
        levelId: 1,
      },
      {
        facetId: 84,
        levelId: 1,
      },
      {
        facetId: 1,
        levelId: 1,
      },
      {
        facetId: 47,
        levelId: 1,
      },
      {
        facetId: 48,
        levelId: 1,
      },
      {
        facetId: 19,
        levelId: 1,
      },
      {
        facetId: 13,
        levelId: 1,
      },
      {
        facetId: 29,
        levelId: 1,
      },
      {
        facetId: 5,
        levelId: 1,
      },
      {
        facetId: 37,
        levelId: 1,
      },
      {
        facetId: 59,
        levelId: 1,
      },
      {
        facetId: 70,
        levelId: 1,
      },
    ],
    vehicleLicences: [
      {
        facetId: 225,
      },
      {
        facetId: 231,
      },
      {
        facetId: 226,
      },
    ],
    languages: [],
    musicAndDance: [
      {
        facetId: 640,
        levelId: 5,
      },
      {
        facetId: 609,
        levelId: 5,
      },
      {
        facetId: 715,
        levelId: 5,
      },
      {
        facetId: 855,
        levelId: 5,
      },
      {
        facetId: 835,
        levelId: 5,
      },
      {
        facetId: 642,
        levelId: 5,
      },
      {
        facetId: 633,
        levelId: 5,
      },
      {
        facetId: 698,
        levelId: 5,
      },
      {
        facetId: 764,
        levelId: 5,
      },
      {
        facetId: 601,
        levelId: 5,
      },
    ],
    otherSkills: [
      {
        facetId: 1038,
      },
      {
        facetId: 982,
      },
      {
        facetId: 1122,
      },
      {
        facetId: 890,
      },
      {
        facetId: 1220,
      },
      {
        facetId: 936,
      },
      {
        facetId: 1105,
      },
      {
        facetId: 900,
      },
      {
        facetId: 1067,
      },
      {
        facetId: 1024,
      },
      {
        facetId: 1080,
      },
      {
        facetId: 1284,
      },
      {
        facetId: 1004,
      },
      {
        facetId: 964,
      },
      {
        facetId: 1001,
      },
      {
        facetId: 1236,
      },
      {
        facetId: 1054,
      },
      {
        facetId: 1272,
      },
      {
        facetId: 903,
      },
      {
        facetId: 920,
      },
      {
        facetId: 1278,
      },
      {
        facetId: 1244,
      },
      {
        facetId: 1287,
      },
      {
        facetId: 1042,
      },
      {
        facetId: 998,
      },
      {
        facetId: 945,
      },
      {
        facetId: 1202,
      },
      {
        facetId: 1265,
      },
      {
        facetId: 971,
      },
    ],
    performances: [
      {
        facetId: 1412,
        levelId: 7,
      },
      {
        facetId: 1316,
        levelId: 7,
      },
      {
        facetId: 1380,
        levelId: 7,
      },
      {
        facetId: 1425,
        levelId: 7,
      },
      {
        facetId: 1321,
        levelId: 7,
      },
      {
        facetId: 1369,
        levelId: 7,
      },
      {
        facetId: 1324,
        levelId: 7,
      },
      {
        facetId: 1319,
        levelId: 7,
      },
    ],
    sports: [
      {
        facetId: 1728,
        levelId: 9,
      },
      {
        facetId: 1752,
        levelId: 9,
      },
      {
        facetId: 1738,
        levelId: 9,
      },
      {
        facetId: 1741,
        levelId: 9,
      },
      {
        facetId: 1852,
        levelId: 9,
      },
      {
        facetId: 1762,
        levelId: 9,
      },
      {
        facetId: 1755,
        levelId: 9,
      },
      {
        facetId: 1746,
        levelId: 9,
      },
      {
        facetId: 1758,
        levelId: 9,
      },
      {
        facetId: 1732,
        levelId: 9,
      },
    ],
    presenting: [],
    measurements: [
      {
        measurementType: "Weight",
        value: 88.9,
      },
      {
        measurementType: "Height",
        value: 175,
      },
    ],
    credits: [
      {
        typeId: 1,
        role: "Demonstrator Model (Series Regular)",
        name: "Take Your Pick",
        company: "Thames",
        director: "Brian Penders",
        highlighted: false,
        position: 21,
      },
      {
        typeId: 37,
        role: "Man On Ground",
        name: "Flying For Fun: An Affair With An Aeroplane",
        company: "BBC",
        venue: "",
        director: "John Elliot",
        highlighted: false,
        position: 0,
      },
      {
        typeId: 7,
        role: "Dancer",
        name: "Imagination",
        company: "Imagination",
        director: "George May",
        highlighted: false,
        position: 7,
      },
      {
        typeId: 1,
        role: "Robbo Violent Man",
        name: "The Bill (Just a Little runaround)",
        company: "Thames",
        director: "Eva Kloughova",
        highlighted: false,
        position: 31,
      },
      {
        typeId: 1,
        role: "Loitering Man",
        name: "Ruth Rendell Mysteries",
        company: "Blue Heaven Productions (GB)",
        venue: "",
        director: "Mary McMurray",
        highlighted: false,
        position: 2,
      },
      {
        typeId: 1,
        role: "Soldier",
        name: "Knights Of God",
        company: "TVS",
        director: "Andrew Morgan",
        highlighted: false,
        position: 38,
      },
      {
        typeId: 1,
        role: "Eamon Aspel (Presenter)",
        name: "For Amusement Only",
        company: "BBC",
        director: "Peter Leslie",
        highlighted: false,
        position: 28,
      },
      {
        typeId: 12,
        role: "Soldier (Lead)",
        name: "Wound Care",
        company: "Cine Western",
        director: "Judith Hann",
        highlighted: false,
        position: 5,
      },
      {
        typeId: 1,
        role: "Good Looking Guy",
        name: "Grange Hill",
        company: "BBC",
        venue: "",
        director: "Albert Barber",
        highlighted: false,
        position: 8,
      },
      {
        typeId: 1,
        role: "Man On Beech",
        name: "Three Up Two Down",
        company: "BBC",
        venue: "",
        director: "John b. Hobbs | Mandie Fletcher",
        highlighted: false,
        position: 3,
      },
      {
        typeId: 12,
        role: "Bret Graham Supporting (Lead)",
        name: "Metropolitan Police Training",
        company: "Metropolitan Police",
        director: "Paul Felstead",
        highlighted: false,
        position: 4,
      },
      {
        typeId: 37,
        role: "Conference Member",
        name: "The Bell Run",
        company: "BBC",
        venue: "",
        director: "Alan Dossor",
        highlighted: false,
        position: 3,
      },
      {
        typeId: 1,
        role: "Army P T Instructor",
        name: "First Born",
        company: "BBC",
        venue: "",
        director: "Philip Savilie",
        highlighted: false,
        position: 10,
      },
      {
        typeId: 37,
        role: "Man In Betting Shop",
        name: "Missing Persons",
        company: "Yorkshire Television",
        venue: "",
        director: "Derek Bennet",
        highlighted: false,
        position: 4,
      },
      {
        typeId: 37,
        role: "Ground Staff",
        name: "Tumbledown",
        company: "BBC",
        venue: "",
        director: "Richard Eyre",
        highlighted: false,
        position: 2,
      },
      {
        typeId: 1,
        role: "Passer By",
        name: "Behaving Badly",
        company: "Channel 4 Television",
        venue: "",
        director: "David Tucker",
        highlighted: false,
        position: 13,
      },
      {
        typeId: 1,
        role: "Working Man",
        name: "The Labours Of Erica",
        company: "Thames Television",
        venue: "",
        director: "John Howard Davies | John Stroud",
        highlighted: false,
        position: 14,
      },
      {
        typeId: 1,
        role: "Solider",
        name: "Vanity Fair",
        company: "BBC",
        venue: "",
        director: "Diarmuid Lawrence| Micheal Owen Morrice",
        highlighted: false,
        position: 4,
      },
      {
        typeId: 1,
        role: "Stunt Actor",
        name: "Hannay",
        company: "Thames Television",
        venue: "",
        director: "Guy Slater",
        highlighted: false,
        position: 7,
      },
      {
        typeId: 4,
        role: "Demonstrator (Lead)",
        name: "Stabilad",
        company: "TVS",
        director: "",
        highlighted: false,
        position: 30,
      },
      {
        typeId: 4,
        role: "Father (Lead)",
        name: "The Bathroom Warehouse",
        company: "TVS",
        director: "",
        highlighted: false,
        position: 28,
      },
      {
        typeId: 1,
        role: "Wedding Guest",
        name: "Christabel",
        company: "A+E Networks",
        venue: "",
        director: "Adrian Shergold",
        highlighted: false,
        position: 11,
      },
      {
        typeId: 1,
        role: "Night Club Dancer",
        name: "Stay Lucky",
        company: "Yorkshire Television",
        venue: "",
        director: "David Reynolds",
        highlighted: false,
        position: 17,
      },
      {
        typeId: 1,
        role: "Pub Customer",
        name: "C.A.T.S. Eyes",
        company: "TVS Television",
        venue: "",
        director: "William Brayne",
        highlighted: false,
        position: 1,
      },
      {
        typeId: 37,
        role: "Olypic Coach",
        name: "The Four Minute Mile",
        company: "Centre films Ltd ( US) Oliver Sullivan Productions (AU) BBC",
        venue: "",
        director: "Jim Goddard",
        highlighted: false,
        position: 1,
      },
      {
        typeId: 1,
        role: "Pianist",
        name: "The Little And Large Show",
        company: "BBC",
        venue: "",
        director: "Bill Wilson| Martin Shardlow",
        highlighted: false,
        position: 9,
      },
      {
        typeId: 12,
        role: "Bernie (Lead)",
        name: "Birdies",
        company: "Revolution Main",
        director: "Lisa Paterson",
        highlighted: false,
        position: 6,
      },
      {
        typeId: 1,
        role: "Steve Atherton",
        name: "THE BILL - Keep on Trucking",
        company: "Thames",
        director: "Graham Harper",
        highlighted: false,
        position: 20,
      },
      {
        typeId: 1,
        role: "Action Man",
        name: "Parallel 9",
        company: "BBC",
        director: "Bob Collins",
        highlighted: false,
        position: 27,
      },
      {
        typeId: 12,
        role: "Mike",
        name: "Washy",
        dateTo: "2020-01-01T00:00:00+00:00",
        company: "LFS",
        director: "James Rush",
        highlighted: false,
        position: 1,
      },
      {
        typeId: 1,
        role: "Guest",
        name: "Chelworth",
        company: "BBC",
        venue: "",
        director: "Roger Bamford",
        highlighted: false,
        position: 16,
      },
      {
        typeId: 3,
        role: "",
        name: "From The Corner Of My Eye",
        dateTo: "2020-01-01T00:00:00+00:00",
        company: "Shot Positiv",
        venue: "",
        director: "",
        highlighted: false,
        position: 0,
      },
      {
        typeId: 1,
        role: "Policeman",
        name: "A Perfect Spy",
        company: "BBC",
        venue: "",
        director: "Peter Smith",
        highlighted: false,
        position: 5,
      },
      {
        typeId: 1,
        role: "Policeman",
        name: "Gentlemen And Players",
        company: "TVS",
        director: "William Brayne",
        highlighted: false,
        position: 37,
      },
      {
        typeId: 1,
        role: "Dancer",
        name: "Summertime Special",
        company: "BBC",
        director: "Ian Hamilton",
        highlighted: false,
        position: 36,
      },
      {
        typeId: 1,
        role: "Hunky Man (Dirty bowling)",
        name: "2point 4 Children",
        company: "BBC",
        director: "Richard Boden",
        highlighted: false,
        position: 32,
      },
      {
        typeId: 1,
        role: "Member of the Hit Squad (Regular Improvisation)",
        name: "Late Late Breakfast Show",
        company: "BBC",
        director: "Nigel Lythgoe",
        highlighted: false,
        position: 23,
      },
      {
        typeId: 4,
        role: "Demonstrator (Lead)",
        name: "Roller Rake",
        company: "TVS",
        director: "",
        highlighted: false,
        position: 29,
      },
      {
        typeId: 1,
        role: "Beech Life Guard",
        name: "The Russ Abbot Show",
        company: "BBC",
        venue: "",
        director: "John Bishop",
        highlighted: false,
        position: 6,
      },
      {
        typeId: 1,
        role: "Diver Stunt work aqualung",
        name: "Only Fools and Horses",
        company: "BBC",
        director: "Ray Butt",
        highlighted: false,
        position: 34,
      },
      {
        typeId: 1,
        role: "Smart Man",
        name: "Executive Stress",
        company: "Thames Television",
        venue: "",
        director: "John Howard Davies | David Askey",
        highlighted: false,
        position: 12,
      },
      {
        typeId: 12,
        role: "Martin  ( TV Presenter, Sports Commentator )",
        name: "What If Sex Was A Sport",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Speedingfilms",
        director: "Torstein Jacobson",
        highlighted: false,
        position: 3,
      },
      {
        typeId: 1,
        role: "Attacker",
        name: "Crimewatch",
        company: "BBC",
        director: "Libby Wiener",
        highlighted: false,
        position: 33,
      },
      {
        typeId: 1,
        role: "Ted",
        name: "London's Burning",
        company: "LWT",
        director: "Ian Knox",
        highlighted: false,
        position: 25,
      },
      {
        typeId: 1,
        role: "Ace Of Clubs",
        name: "Rory Bremner",
        company: "BBC",
        venue: "",
        director: "Kevin Bishop (IV)",
        highlighted: false,
        position: 15,
      },
      {
        typeId: 1,
        role: "Jack the Minister of the Interior",
        name: "Vote For Them",
        company: "Thames",
        director: "James Ormerod",
        highlighted: false,
        position: 29,
      },
      {
        typeId: 1,
        role: "Sound Man",
        name: "Shelley",
        company: "Thames",
        director: "Anthony Parker",
        highlighted: false,
        position: 35,
      },
      {
        typeId: 1,
        role: "Gangster",
        name: "EastEnders",
        company: "BBC",
        venue: "",
        director: "Garth Tucker",
        highlighted: false,
        position: 0,
      },
      {
        typeId: 1,
        role: "Games Host (Series Regular)",
        name: "Trick Or Treat",
        company: "LWT",
        director: "Michael Hurl",
        highlighted: false,
        position: 22,
      },
      {
        typeId: 1,
        role: "Magicians Assistant (Series Regular)",
        name: "The Paul Daniels Magic Show",
        company: "BBC",
        director: "Geoff Miles",
        highlighted: false,
        position: 24,
      },
      {
        typeId: 1,
        role: "Action Man",
        name: "Big Breakfast",
        company: "Channel 4",
        director: "John MacKenzie",
        highlighted: false,
        position: 26,
      },
      {
        typeId: 1,
        role: "AA Man",
        name: "Bobby Davro Show TV Weekly",
        company: "TVS",
        director: "Nigel Lythgoe",
        highlighted: false,
        position: 30,
      },
      {
        typeId: 1,
        role: "Lorry Hijacker",
        name: "Crimewatch",
        company: "BBC",
        director: "Helen Phelps",
        highlighted: false,
        position: 19,
      },
      {
        typeId: 1,
        role: "Trapped Man",
        name: "Casualty",
        company: "BBC",
        venue: "",
        director: "",
        highlighted: false,
        position: 18,
      },
    ],
    creditHeadings: [
      {
        orderByDate: false,
        isHidden: false,
        position: 3,
        creditType: {
          id: 1,
          name: "Television",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 0,
        creditType: {
          id: 3,
          name: "Feature Film",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 4,
        creditType: {
          id: 4,
          name: "Commercial",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 2,
        creditType: {
          id: 7,
          name: "Corporate",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 1,
        creditType: {
          id: 12,
          name: "Film",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 5,
        creditType: {
          id: 37,
          name: "Television Movie",
          hasVenue: false,
        },
      },
    ],
    isPregnant: false,
    playingAgeFrom: 45,
    playingAgeTo: 60,
    dateOfBirthUtc: "1960-02-15T00:00:00+00:00",
    height: 175,
    viewPin: "1018-3494-8061",
    isVisibleActualAge: false,
    isVisibleDisability: false,
    isVisibleGender: false,
  },
  {
    id: "2f97ad90-fa59-4701-be77-fb6297f8e45a",
    artistRef: "M80408",
    mainPhoto: {
      id: "7d237bd5-0f6d-47c1-9687-8b764a051b01",
      fileName: "M00080408-0114",
      description: "",
      photographer: {
        name: "Andrew Chapman",
      },
    },
    galleryPhotos: [
      {
        position: 13,
        isHidden: true,
        id: "5ffa785e-25cc-439f-974e-001638ed8a14",
        fileName: "M00080408-0125",
        description: "",
        photographer: {
          name: "Andrew Chapman",
        },
      },
      {
        position: 2,
        isHidden: false,
        id: "028c5106-fadb-4f06-99fc-017cf8202542",
        fileName: "M00080408-0102",
        description: "",
        photographer: {
          name: "Andrew Chapman",
        },
      },
      {
        position: 11,
        isHidden: false,
        id: "68de4349-a3d4-4675-a9cd-25416be30b91",
        fileName: "M00080408-0115",
        description: "",
        photographer: {
          name: "Andrew Chapman",
        },
      },
      {
        position: 1,
        isHidden: false,
        id: "4f14fdaf-42d9-4e27-b21d-27799fc68a2a",
        fileName: "M00080408-01",
        photographer: {
          name: "Andrew Chapman",
        },
      },
      {
        position: 4,
        isHidden: false,
        id: "8ed162b3-9022-429d-b94b-36ca2524cc6d",
        fileName: "M00080408-0108",
        description: "",
        photographer: {
          name: "Andrew Chapman",
        },
      },
      {
        position: 7,
        isHidden: false,
        id: "dbe4dda8-4dcc-4391-9e77-5c22d88726cd",
        fileName: "M00080408-0109",
        description: "",
        photographer: {
          name: "Andrew Chapman",
        },
      },
      {
        position: 0,
        isHidden: false,
        id: "cacb1ac0-59cc-4629-988e-5f3f4b556b41",
        fileName: "M00080408-0110",
        description: "",
        photographer: {
          name: "Andrew Chapman",
        },
      },
      {
        position: 12,
        isHidden: false,
        id: "4706232b-56f9-43ea-9ba0-7c6ba06a59c6",
        fileName: "M00080408-0105",
        description: "",
        photographer: {
          name: "Andrew Chapman",
        },
      },
      {
        position: 8,
        isHidden: false,
        id: "2e24273d-a132-44df-85e5-936e85115118",
        fileName: "M00080408-0112",
        description: "",
        photographer: {
          name: "Andrew Chapman",
        },
      },
      {
        position: 6,
        isHidden: false,
        id: "500516c6-6efe-4db8-a206-dc5065abbaa5",
        fileName: "M00080408-0103",
        description: "",
        photographer: {
          name: "Andrew Chapman",
        },
      },
      {
        position: 10,
        isHidden: true,
        id: "d6dbec40-5810-43e2-a92c-e267eedbfc99",
        fileName: "M00080408-0104",
        description: "",
        photographer: {
          name: "Andrew Chapman",
        },
      },
      {
        position: 9,
        isHidden: false,
        id: "fbcf41b5-0145-4707-a6c3-e590cf31362b",
        fileName: "M00080408-0113",
        description: "",
        photographer: {
          name: "Andrew Chapman",
        },
      },
      {
        position: 5,
        isHidden: false,
        id: "74d2f436-cb46-4a50-9bde-f4ba11b23324",
        fileName: "M00080408-0107",
        description: "",
        photographer: {
          name: "Andrew Chapman",
        },
      },
      {
        position: 3,
        isHidden: false,
        id: "17f1fee1-33d2-4796-9ba4-fa66c08b4d10",
        fileName: "M00080408-0106",
        description: "",
        photographer: {
          name: "Andrew Chapman",
        },
      },
    ],
    forename: "LUKE",
    surname: "BROUGHTON",
    performerType: "Performer",
    publicationCode: 1,
    contract: {
      membership: "performerfamily",
      status: "current",
      expirationDate: "2020-05-12T00:00:00+00:00",
    },
    mainAgent: {
      agentRef: 116,
      name: "PEMBERTON ASSOCIATES LTD",
      email: "enquiries@spotlight.com",
      phone: "020 7437 7631",
      mobilePhone: "020 7437 7631",
      website: "www.spotlight.com",
      address: {
        id: 111,
        addressLine1: "Spotlight",
        addressLine2: "7 Leicester Place",
        addressLine3: "London",
        addressLine4: "",
        country: "",
        postCode: "WC2H 7RJ",
      },
    },
    agents: [
      {
        agentRef: 116,
        name: "PEMBERTON ASSOCIATES LTD",
        email: "enquiries@spotlight.com",
        phone: "020 7437 7631",
        mobilePhone: "020 7437 7631",
        website: "www.spotlight.com",
        address: {
          id: 111,
          addressLine1: "Spotlight",
          addressLine2: "7 Leicester Place",
          addressLine3: "London",
          addressLine4: "",
          country: "",
          postCode: "WC2H 7RJ",
        },
      },
    ],
    dramaSchools: [],
    showreelsCount: 1,
    audioclipsCount: 0,
    locations: [],
    castingDirectorNotes: [],
    gender: [5203],
    disabilities: [],
    nationalities: [],
    appearances: [1716],
    eyeColours: [246],
    facialHairs: [],
    hairColours: [265],
    hairLength: [277],
    beltNotes: [],
    accentsAndDialects: [
      {
        facetId: 19,
        levelId: 2,
      },
      {
        facetId: 27,
        levelId: 1,
      },
      {
        facetId: 37,
        levelId: 1,
      },
      {
        facetId: 44,
        levelId: 1,
      },
      {
        facetId: 55,
        levelId: 1,
      },
      {
        facetId: 21,
        levelId: 1,
      },
      {
        facetId: 20,
        levelId: 1,
      },
      {
        facetId: 1,
        levelId: 1,
      },
      {
        facetId: 38,
        levelId: 1,
      },
      {
        facetId: 5,
        levelId: 1,
      },
      {
        facetId: 70,
        levelId: 1,
      },
      {
        facetId: 123,
        levelId: 1,
      },
      {
        facetId: 72,
        levelId: 1,
      },
      {
        facetId: 16,
        levelId: 1,
      },
    ],
    vehicleLicences: [
      {
        facetId: 225,
      },
    ],
    languages: [
      {
        facetId: 294,
        levelId: 4,
      },
    ],
    musicAndDance: [
      {
        facetId: 623,
        levelId: 5,
      },
      {
        facetId: 619,
        levelId: 5,
      },
    ],
    otherSkills: [
      {
        facetId: 890,
      },
      {
        facetId: 900,
      },
      {
        facetId: 954,
      },
      {
        facetId: 922,
      },
      {
        facetId: 903,
      },
      {
        facetId: 913,
      },
      {
        facetId: 1003,
      },
      {
        facetId: 972,
      },
    ],
    performances: [
      {
        facetId: 1369,
        levelId: 7,
      },
      {
        facetId: 1343,
        levelId: 7,
      },
      {
        facetId: 1324,
        levelId: 7,
      },
      {
        facetId: 1333,
        levelId: 7,
      },
      {
        facetId: 1330,
        levelId: 7,
      },
      {
        facetId: 1328,
        levelId: 7,
      },
      {
        facetId: 1383,
        levelId: 7,
      },
      {
        facetId: 1316,
        levelId: 7,
      },
      {
        facetId: 1361,
        levelId: 7,
      },
    ],
    sports: [
      {
        facetId: 1751,
        levelId: 9,
      },
      {
        facetId: 1739,
        levelId: 9,
      },
      {
        facetId: 1729,
        levelId: 9,
      },
      {
        facetId: 1762,
        levelId: 10,
      },
      {
        facetId: 1770,
        levelId: 9,
      },
      {
        facetId: 1780,
        levelId: 9,
      },
      {
        facetId: 1764,
        levelId: 10,
      },
      {
        facetId: 1738,
        levelId: 10,
      },
      {
        facetId: 1774,
        levelId: 9,
      },
      {
        facetId: 1734,
        levelId: 9,
      },
    ],
    presenting: [],
    measurements: [
      {
        measurementType: "Weight",
        value: 73.02,
      },
      {
        measurementType: "Height",
        value: 182,
      },
    ],
    credits: [
      {
        typeId: 7,
        role: "Safety Officer Steven",
        name: "EDF training",
        dateTo: "2014-01-01T00:00:00+00:00",
        company: "HU Media",
        director: "Graeme Kitto",
        highlighted: false,
        position: 4,
      },
      {
        typeId: 12,
        role: "Cop 2",
        name: "BOY A",
        dateTo: "2007-01-01T00:00:00+00:00",
        company: "Cuba Pictures",
        director: "John Crowley",
        highlighted: false,
        position: 52,
      },
      {
        typeId: 4,
        role: "Dad",
        name: "Life could be a dream with Park",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "Add on TV",
        director: "Julian Kronfli",
        highlighted: false,
        position: 53,
      },
      {
        typeId: 0,
        role: "Centurion",
        name: "Horrible Histories - The Ruthless Romans",
        dateTo: "2011-01-01T00:00:00+00:00",
        company: "Birmingham Stage Company",
        director: "Phil Clark",
        highlighted: false,
        position: 33,
      },
      {
        typeId: 0,
        role: "Luke",
        name: "Free Falling",
        dateTo: "2005-01-01T00:00:00+00:00",
        company: "Red Ladder Theatre Co",
        director: "Wendy Harris",
        highlighted: false,
        position: 40,
      },
      {
        typeId: 1,
        role: "Policeman",
        name: "Hollyoaks",
        dateTo: "2012-01-01T00:00:00+00:00",
        company: "Lime Pictures",
        director: "Mickey Jones",
        highlighted: false,
        position: 14,
      },
      {
        typeId: 0,
        role: "Chris",
        name: "Cutting the Cake",
        dateTo: "2018-01-01T00:00:00+00:00",
        company: "Slung Low Shorts",
        director: "Olivia Race",
        highlighted: false,
        position: 26,
      },
      {
        typeId: 0,
        role: "Storey/Smears",
        name: "Awful Egyptians, Sydney/Melbourne",
        dateTo: "2013-01-01T00:00:00+00:00",
        company: "Birmingham Stage Company and Sydney Opera House",
        director: "Phil Clark",
        highlighted: false,
        position: 29,
      },
      {
        typeId: 0,
        role: "Pete/JP",
        name: "World's Apart",
        dateTo: "2006-01-01T00:00:00+00:00",
        company: "Red Ladder Theatre Co",
        director: "Juliet Ellis",
        highlighted: false,
        position: 37,
      },
      {
        typeId: 1,
        role: "Thomas Bates",
        name: "Gunpowder",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "BBC (Kudos)",
        director: "J Blakeston",
        highlighted: false,
        position: 10,
      },
      {
        typeId: 7,
        role: "Luke",
        name: "Clearing the way",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "HU media",
        director: "Graeme Kitto",
        highlighted: false,
        position: 1,
      },
      {
        typeId: 2,
        role: "Dave",
        name: "FREE-THINKING - A PAINTER'S SKY",
        dateTo: "2007-01-01T00:00:00+00:00",
        company: "BBC Radio 3",
        director: "Gary Brown",
        highlighted: false,
        position: 51,
      },
      {
        typeId: 2,
        role: "Kenny & Estate Agent",
        name: "Des Res",
        dateTo: "2009-01-01T00:00:00+00:00",
        company: "BBC Radio 4",
        director: "Gary Brown",
        highlighted: false,
        position: 47,
      },
      {
        typeId: 0,
        role: "Storey",
        name: "Horrible Histories - The Awful Egyptians",
        dateTo: "2011-01-01T00:00:00+00:00",
        company: "Birmingham Stage Company",
        director: "Phil Clark",
        highlighted: false,
        position: 32,
      },
      {
        typeId: 1,
        role: "Ian",
        name: "HOLLYOAKS",
        dateTo: "2007-01-01T00:00:00+00:00",
        company: "Lime Pictures",
        director: "Nicholas Ferguson",
        highlighted: false,
        position: 17,
      },
      {
        typeId: 1,
        role: "Paul Dean",
        name: "Crimewatch Solved",
        dateTo: "2003-01-01T00:00:00+00:00",
        company: "BBC Television",
        director: "Gretchen Shoring",
        highlighted: false,
        position: 21,
      },
      {
        typeId: 1,
        role: "Paul Grigson",
        name: "HEARTBEAT",
        dateTo: "2007-01-01T00:00:00+00:00",
        company: "ITV Productions",
        director: "Judith Dine",
        highlighted: false,
        position: 16,
      },
      {
        typeId: 1,
        role: "The Paramedic",
        name: "The Driver",
        dateTo: "2014-01-01T00:00:00+00:00",
        company: "Red Productions",
        director: "Jamie Payne",
        highlighted: false,
        position: 12,
      },
      {
        typeId: 1,
        role: "Frank",
        name: "Merseybeat",
        dateTo: "2003-01-01T00:00:00+00:00",
        company: "BBC Television",
        director: "Adrian Bean",
        highlighted: false,
        position: 19,
      },
      {
        typeId: 1,
        role: "Carl Weathers",
        name: "4 O Clock Club",
        dateTo: "2014-01-01T00:00:00+00:00",
        company: "Cbbc",
        director: "Tim Hopewell",
        highlighted: false,
        position: 11,
      },
      {
        typeId: 7,
        role: "Ground Crew Corporal",
        name: "A Bad Day At The Squadron",
        dateTo: "2004-01-01T00:00:00+00:00",
        company: "The Edge Picture Company/Ministry of Defence",
        director: "",
        highlighted: false,
        position: 8,
      },
      {
        typeId: 0,
        role: "Hortensio/The Pedant",
        name: "The Taming of the Shrew",
        dateTo: "2009-01-01T00:00:00+00:00",
        company: "Mooted Theatre",
        director: "Mark France",
        highlighted: false,
        position: 35,
      },
      {
        typeId: 1,
        role: "Aaron",
        name: "Burn It",
        dateTo: "2002-01-01T00:00:00+00:00",
        company: "Red Productions",
        director: "Sheree Folkeson",
        highlighted: false,
        position: 23,
      },
      {
        typeId: 1,
        role: "Public Gallery Member",
        name: "A Touch of Frost",
        dateTo: "2002-01-01T00:00:00+00:00",
        company: "Yorkshire Television",
        director: "",
        highlighted: false,
        position: 24,
      },
      {
        typeId: 2,
        role: "Robbie",
        name: "MIRACLE WORKER",
        dateTo: "2008-01-01T00:00:00+00:00",
        company: "BBC Radio 4",
        director: "Gary Brown",
        highlighted: false,
        position: 50,
      },
      {
        typeId: 2,
        role: "Damien Nash/Sammy",
        name: "STONE",
        dateTo: "2012-01-01T00:00:00+00:00",
        company: "BBC Radio Drama",
        director: "Nadia Molinari",
        highlighted: false,
        position: 45,
      },
      {
        typeId: 0,
        role: "Chris",
        name: "Afloat",
        dateTo: "2012-01-01T00:00:00+00:00",
        company: "Park Bench Theatre, Hull Truck",
        director: "Sarah Louise Davies",
        highlighted: false,
        position: 31,
      },
      {
        typeId: 0,
        role: "Lussurioso",
        name: "The Revenger's Tragedy",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "Well Fangled Theatre",
        director: "Mark France",
        highlighted: false,
        position: 27,
      },
      {
        typeId: 1,
        role: "Robert Barry",
        name: "THE ROYAL TODAY",
        dateTo: "2007-01-01T00:00:00+00:00",
        company: "ITV Productions",
        director: "Chris Corcoran",
        highlighted: false,
        position: 15,
      },
      {
        typeId: 8,
        role: "Nick",
        name: "Spiral",
        dateTo: "2010-01-01T00:00:00+00:00",
        company: "Independent",
        director: "Pete Richmond",
        highlighted: false,
        position: 5,
      },
      {
        typeId: 0,
        role: "Brian",
        name: "Love Letters",
        dateTo: "2005-01-01T00:00:00+00:00",
        company: "The Ashton Group Theatre Ltd",
        director: "Rachel Ashton",
        highlighted: false,
        position: 39,
      },
      {
        typeId: 2,
        role: "Steven",
        name: "ID",
        dateTo: "2010-01-01T00:00:00+00:00",
        company: "BBC Radio 4",
        director: "Gary Brown",
        highlighted: false,
        position: 46,
      },
      {
        typeId: 0,
        role: "Sprogger",
        name: "The Worm Collector",
        dateTo: "2010-01-01T00:00:00+00:00",
        company: "West Yorkshire Playhouse",
        director: "Gail McIntyre",
        highlighted: false,
        position: 34,
      },
      {
        typeId: 0,
        role: "Various",
        name: "Nola",
        dateTo: "2012-01-01T00:00:00+00:00",
        company: "Look Left Look Right",
        director: "Ellie Browning",
        highlighted: false,
        position: 30,
      },
      {
        typeId: 33,
        role: "Various",
        name: "The Shed Crew",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "West Yorkshire Playhouse",
        director: "Tom Birch",
        highlighted: false,
        position: 2,
      },
      {
        typeId: 7,
        role: "Pete",
        name: "Wakefield District Housing",
        dateTo: "2005-01-01T00:00:00+00:00",
        company: "Dead Earnest Theatre",
        director: "Rachel Scott",
        highlighted: false,
        position: 7,
      },
      {
        typeId: 1,
        role: "Terry",
        name: "City Life - On The Out",
        dateTo: "2003-01-01T00:00:00+00:00",
        company: "Granada Television",
        director: "Matt Bloom",
        highlighted: false,
        position: 20,
      },
      {
        typeId: 1,
        role: "Leslie",
        name: "Torn",
        dateTo: "2005-01-01T00:00:00+00:00",
        company: "BBC3",
        director: "Avie Luthra",
        highlighted: false,
        position: 18,
      },
      {
        typeId: 1,
        role: "Weir",
        name: "Buried",
        dateTo: "2002-01-01T00:00:00+00:00",
        company: "World Productions",
        director: "Kenny Glenaan",
        highlighted: false,
        position: 22,
      },
      {
        typeId: 33,
        role: "Dobsy",
        name: "Brassic",
        dateTo: "2014-01-01T00:00:00+00:00",
        company: "Rollem Productions",
        director: "Kay Mellor",
        highlighted: false,
        position: 3,
      },
      {
        typeId: 2,
        role: "Weeks and Lad 1",
        name: "STONE",
        dateTo: "2009-01-01T00:00:00+00:00",
        company: "BBC Radio 4",
        director: "Stefan Escreet",
        highlighted: false,
        position: 48,
      },
      {
        typeId: 7,
        role: "Alan",
        name: "Vista",
        dateTo: "2007-01-01T00:00:00+00:00",
        company: "Spoken Image",
        director: "",
        highlighted: false,
        position: 6,
      },
      {
        typeId: 1,
        role: "Hotel Guest",
        name: "Birthday Girl",
        dateTo: "2001-01-01T00:00:00+00:00",
        company: "Yorkshire Television",
        director: "Morag Fullerton",
        highlighted: false,
        position: 25,
      },
      {
        typeId: 26,
        role: "Various",
        name: "The Tempest/Much Ado About Nothing/Romeo and Juliet",
        dateTo: "2008-01-01T00:00:00+00:00",
        company: "West Yorkshire Playhouse",
        director: "Daniel Bye",
        highlighted: false,
        position: 9,
      },
      {
        typeId: 1,
        role: "D.C. Archer",
        name: "Emmerdale (6 Eps)",
        dateTo: "2012-01-01T00:00:00+00:00",
        company: "ITV Yorkshire",
        director: "Various Directors",
        highlighted: false,
        position: 13,
      },
      {
        typeId: 2,
        role: "Rob/Estate Agent",
        name: "IOU",
        dateTo: "2013-01-01T00:00:00+00:00",
        company: "BBC Radio Drama",
        director: "Gary Brown",
        highlighted: false,
        position: 44,
      },
      {
        typeId: 2,
        role: "George Harrison",
        name: "SORRY BOYS YOU FAILED THE AUDITION",
        dateTo: "2013-01-01T00:00:00+00:00",
        company: "BBC Radio",
        director: "Gary Brown",
        highlighted: false,
        position: 43,
      },
      {
        typeId: 0,
        role: "Muller/Khukov",
        name: "Stalingrad",
        dateTo: "2004-01-01T00:00:00+00:00",
        company: "Dead Earnest Theatre",
        director: "Ashley Barnes",
        highlighted: false,
        position: 42,
      },
      {
        typeId: 0,
        role: "Youth Employment Officer, Farmer & Ensemble",
        name: "KES",
        dateTo: "2013-01-01T00:00:00+00:00",
        company: "Derby Theatre",
        director: "Sarah Brigham",
        highlighted: false,
        position: 28,
      },
      {
        typeId: 0,
        role: "Mac",
        name: "Now is the Hour",
        dateTo: "2008-01-01T00:00:00+00:00",
        company: "Crossroads Theatre",
        director: "Tom Cornford",
        highlighted: false,
        position: 36,
      },
      {
        typeId: 0,
        role: "Young Paul",
        name: "Crap Dad",
        dateTo: "2004-01-01T00:00:00+00:00",
        company: "West Yorkshire Playhouse",
        director: "Gail McIntyre",
        highlighted: false,
        position: 41,
      },
      {
        typeId: 2,
        role: "Boy",
        name: "PINS AND NEEDLES",
        dateTo: "2008-01-01T00:00:00+00:00",
        company: "BBC Radio 4",
        director: "Pauline Harris",
        highlighted: false,
        position: 49,
      },
      {
        typeId: 0,
        role: "Luke/Jay/Sam",
        name: "All Talk",
        dateTo: "2006-01-01T00:00:00+00:00",
        company: "M6 Theatre",
        director: "Stefan Escreet",
        highlighted: false,
        position: 38,
      },
      {
        typeId: 4,
        role: "Gamer",
        name: "1 finger food",
        dateTo: "2008-01-01T00:00:00+00:00",
        company: "Rustlers",
        director: "",
        highlighted: false,
        position: 54,
      },
    ],
    creditHeadings: [
      {
        orderByDate: false,
        isHidden: false,
        position: 1,
        creditType: {
          id: 0,
          name: "Stage",
          hasVenue: true,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 0,
        creditType: {
          id: 1,
          name: "Television",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 2,
        creditType: {
          id: 2,
          name: "Radio",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 4,
        creditType: {
          id: 4,
          name: "Commercial",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 5,
        creditType: {
          id: 7,
          name: "Corporate",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 7,
        creditType: {
          id: 8,
          name: "Short Film",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 3,
        creditType: {
          id: 12,
          name: "Film",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 8,
        creditType: {
          id: 26,
          name: "Workshop",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 6,
        creditType: {
          id: 33,
          name: "Rehearsed Reading",
          hasVenue: true,
        },
      },
    ],
    isPregnant: false,
    playingAgeFrom: 30,
    playingAgeTo: 40,
    height: 182,
    viewPin: "4134-5616-5195",
    isVisibleActualAge: false,
    isVisibleDisability: false,
    isVisibleGender: false,
  },
  {
    id: "e1762347-64df-4265-afb6-ffa5236e0fe7",
    artistRef: "M273478",
    mainPhoto: {
      id: "5df78bae-7e3f-42b7-a5bd-681ddb1b729d",
      fileName: "94d0e8a3-2467-4c5d-8ba2-7dea5d35f0fc",
      description: "",
      photographer: {
        name: "Dominic Owen",
      },
    },
    galleryPhotos: [
      {
        position: 1,
        isHidden: false,
        id: "3465fd19-9cfd-40a5-8342-678b2a275547",
        fileName: "a054c9b4-31c1-4452-a6fb-2bf2eefe309d",
        description: "",
        photographer: {
          name: "Dominic Owen",
        },
      },
      {
        position: 3,
        isHidden: false,
        id: "4da151a0-af07-4c77-9ab0-7bf9e416d4b8",
        fileName: "1e5d97b2-841b-4064-b555-232fb3f275a9",
        description: "",
        photographer: {
          name: "Dominic Owen",
        },
      },
      {
        position: 2,
        isHidden: false,
        id: "cc495ee8-e883-47be-a2fc-9c8caa2587b5",
        fileName: "4e5854a4-53ed-43d3-8bf4-9abfbd7ebb8a",
        description: "",
        photographer: {
          name: "Dominic Owen",
        },
      },
    ],
    forename: "LUKE",
    surname: "CARTWRIGHT",
    performerType: "Performer",
    publicationCode: 1,
    contract: {
      membership: "performerfamily",
      status: "current",
      expirationDate: "2020-05-12T00:00:00+00:00",
    },
    mainAgent: {
      agentRef: 13511,
      name: "ROBERTS & DAY MANAGEMENT",
      email: "enquiries@spotlight.com",
      phone: "020 7437 7631",
      mobilePhone: "020 7437 7631",
      website: "www.spotlight.com",
      address: {
        id: 111,
        addressLine1: "Spotlight",
        addressLine2: "7 Leicester Place",
        addressLine3: "London",
        addressLine4: "",
        country: "",
        postCode: "WC2H 7RJ",
      },
    },
    agents: [
      {
        agentRef: 13511,
        name: "ROBERTS & DAY MANAGEMENT",
        email: "enquiries@spotlight.com",
        phone: "020 7437 7631",
        mobilePhone: "020 7437 7631",
        website: "www.spotlight.com",
        address: {
          id: 111,
          addressLine1: "Spotlight",
          addressLine2: "7 Leicester Place",
          addressLine3: "London",
          addressLine4: "",
          country: "",
          postCode: "WC2H 7RJ",
        },
      },
    ],
    dramaSchools: [],
    showreelsCount: 1,
    audioclipsCount: 0,
    locations: [
      {
        locationId: "ChIJc2fVfoPXekgRApLOHfrVYYY",
        position: 0,
      },
      {
        locationId: "ChIJzXkHOdIyeEgREinv5XDJr1Q",
        position: 1,
      },
    ],
    castingDirectorNotes: [],
    gender: [5203],
    disabilities: [],
    nationalities: [2198],
    appearances: [1716, 1715],
    eyeColours: [246],
    facialHairs: [],
    hairColours: [272],
    hairLength: [277],
    beltNotes: [5104],
    accentsAndDialects: [],
    vehicleLicences: [],
    languages: [],
    musicAndDance: [
      {
        facetId: 600,
        levelId: 6,
      },
      {
        facetId: 608,
        levelId: 5,
      },
      {
        facetId: 611,
        levelId: 6,
      },
      {
        facetId: 669,
        levelId: 5,
      },
      {
        facetId: 605,
        levelId: 5,
      },
      {
        facetId: 694,
        levelId: 5,
      },
      {
        facetId: 591,
        levelId: 5,
      },
      {
        facetId: 846,
        levelId: 5,
      },
      {
        facetId: 654,
        levelId: 5,
      },
      {
        facetId: 623,
        levelId: 5,
      },
      {
        facetId: 824,
        levelId: 5,
      },
      {
        facetId: 678,
        levelId: 5,
      },
      {
        facetId: 760,
        levelId: 5,
      },
      {
        facetId: 865,
        levelId: 5,
      },
      {
        facetId: 615,
        levelId: 5,
      },
    ],
    otherSkills: [],
    performances: [],
    sports: [],
    presenting: [],
    measurements: [
      {
        measurementType: "LowerVocalNote",
        value: 25,
      },
      {
        measurementType: "UpperVocalNote",
        value: 43,
      },
      {
        measurementType: "Height",
        value: 172,
      },
    ],
    credits: [
      {
        typeId: 7,
        role: "singer/dancer",
        name: "Big Men In Town",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Live Fairytales",
        director: "Adam Curtis",
        highlighted: false,
        position: 4,
      },
      {
        typeId: 16,
        role: "Dancer",
        name: "Fame the reunion",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "",
        director: "",
        highlighted: false,
        position: 6,
      },
      {
        typeId: 13,
        role: "Coma Baby 1",
        name: "Bright LIghts big city",
        dateTo: "2018-01-01T00:00:00+00:00",
        company: "",
        director: "Graham Hubbard",
        highlighted: false,
        position: 8,
      },
      {
        typeId: 1,
        role: "Dancer/Flag Bearer",
        name: "ICCU Cricket World Cup",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "",
        director: "Mark Murphy/ Katie Prince",
        highlighted: false,
        position: 5,
      },
      {
        typeId: 16,
        role: "Dancer",
        name: "Identity",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Chris Tendai Company",
        director: "Denzel Westley-Sanderson",
        highlighted: false,
        position: 3,
      },
      {
        typeId: 32,
        role: "Dancer",
        name: "The Cromer Pier Christmas show",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Cromer Pier Pavilion Theatre",
        director: "Dianne Cooke",
        highlighted: false,
        position: 2,
      },
      {
        typeId: 16,
        role: "Dancer",
        name: "Identity",
        dateTo: "2020-01-01T00:00:00+00:00",
        company: "CTC dance company",
        director: "Christopher Tendai and Denzel Westley-Sanderson",
        highlighted: false,
        position: 1,
      },
      {
        typeId: 41,
        role: "Ensemble",
        name: "Beauty and the Beast",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "Drops of Lights CIC",
        director: "James Lacey",
        highlighted: false,
        position: 9,
      },
      {
        typeId: 16,
        role: "Ensemble Dancer",
        name: "Romeo and Juliet",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "",
        director: "Andrew Hall",
        highlighted: false,
        position: 7,
      },
    ],
    creditHeadings: [
      {
        orderByDate: false,
        isHidden: true,
        position: 5,
        creditType: {
          id: 1,
          name: "Television",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 1,
        creditType: {
          id: 7,
          name: "Corporate",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 3,
        creditType: {
          id: 13,
          name: "Musical",
          hasVenue: true,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 2,
        creditType: {
          id: 16,
          name: "Dance",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 0,
        creditType: {
          id: 32,
          name: "Cabaret",
          hasVenue: true,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 4,
        creditType: {
          id: 41,
          name: "Pantomime",
          hasVenue: true,
        },
      },
    ],
    isPregnant: false,
    playingAgeFrom: 16,
    playingAgeTo: 25,
    dateOfBirthUtc: "1998-01-16T00:00:00+00:00",
    height: 172,
    viewPin: "7175-4507-5474",
    isVisibleActualAge: true,
    isVisibleDisability: false,
    isVisibleGender: false,
  },
  {
    id: "86a66abc-1d42-4ec5-857a-f70150e56ed8",
    artistRef: "M186630",
    mainPhoto: {
      id: "eca85d93-4ae8-4f5e-afff-6182c660ea63",
      fileName: "M00186630-1608",
      description: "",
      photographer: {
        name: "Rebecca Brooker",
      },
    },
    galleryPhotos: [
      {
        position: 4,
        isHidden: true,
        id: "7a3b4a5a-4c45-4f48-a26d-05682797c4ce",
        fileName: "M00186630-1605",
        description: "",
        photographer: {
          name: "Rebecca Brooker",
        },
      },
      {
        position: 9,
        isHidden: false,
        id: "60fc8c94-3196-4f0c-ad18-2b90b633a8a8",
        fileName: "M00186630-1610",
        description: "",
        photographer: {
          name: "Rebecca Brooker",
        },
      },
      {
        position: 2,
        isHidden: true,
        id: "1356a29a-80d4-41a5-b7ac-3e7847465031",
        fileName: "M00186630-1603",
        description: "",
        photographer: {
          name: "Rebecca Brooker",
        },
      },
      {
        position: 5,
        isHidden: false,
        id: "f4075e4f-9b95-4fd3-b53d-8f08318d0ad5",
        fileName: "M00186630-1606",
        description: "",
        photographer: {
          name: "Rebecca Brooker",
        },
      },
      {
        position: 6,
        isHidden: false,
        id: "452ee1ab-c9eb-4c39-89f9-9e71d6fea05c",
        fileName: "M00186630-1607",
        description: "",
        photographer: {
          name: "Rebecca Brooker",
        },
      },
      {
        position: 3,
        isHidden: true,
        id: "8a98253c-573c-4c16-9327-9fb0dc9d8ff5",
        fileName: "M00186630-16",
        photographer: {
          name: "Rebecca Brooker",
        },
      },
      {
        position: 8,
        isHidden: false,
        id: "9c926833-126c-4ea0-be6f-ad8c32d9b3df",
        fileName: "M00186630-1609",
        description: "",
        photographer: {
          name: "Rebecca Brooker",
        },
      },
      {
        position: 1,
        isHidden: true,
        id: "b3637bff-1d5a-4556-84f9-b3c4533a27c3",
        fileName: "M00186630-1604",
        description: "",
        photographer: {
          name: "Rebecca Brooker",
        },
      },
      {
        position: 0,
        isHidden: true,
        id: "ec266cfe-d1be-452f-bd8e-fe9bcdcb25ab",
        fileName: "M00186630-1602",
        description: "",
        photographer: {
          name: "Rebecca Brooker",
        },
      },
    ],
    forename: "LUKE",
    surname: "CHARLESWORTH",
    performerType: "YoungPerformer",
    publicationCode: 16,
    contract: {
      membership: "youngperformerfamily",
      status: "current",
      expirationDate: "2020-05-12T00:00:00+00:00",
    },
    mainAgent: {
      agentRef: 9049,
      name: "SILVERLEE MANAGEMENT",
      email: "enquiries@spotlight.com",
      phone: "020 7437 7631",
      mobilePhone: "020 7437 7631",
      website: "www.spotlight.com",
      address: {
        id: 111,
        addressLine1: "Spotlight",
        addressLine2: "7 Leicester Place",
        addressLine3: "London",
        addressLine4: "",
        country: "",
        postCode: "WC2H 7RJ",
      },
    },
    agents: [
      {
        agentRef: 9049,
        name: "SILVERLEE MANAGEMENT",
        email: "enquiries@spotlight.com",
        phone: "020 7437 7631",
        mobilePhone: "020 7437 7631",
        website: "www.spotlight.com",
        address: {
          id: 111,
          addressLine1: "Spotlight",
          addressLine2: "7 Leicester Place",
          addressLine3: "London",
          addressLine4: "",
          country: "",
          postCode: "WC2H 7RJ",
        },
      },
    ],
    dramaSchools: [],
    showreelsCount: 0,
    audioclipsCount: 0,
    locations: [],
    castingDirectorNotes: [],
    gender: [5203],
    disabilities: [],
    nationalities: [],
    appearances: [1716],
    eyeColours: [246],
    facialHairs: [],
    hairColours: [263],
    hairLength: [277],
    beltNotes: [],
    accentsAndDialects: [
      {
        facetId: 44,
        levelId: 1,
      },
      {
        facetId: 20,
        levelId: 1,
      },
      {
        facetId: 38,
        levelId: 1,
      },
      {
        facetId: 32,
        levelId: 2,
      },
    ],
    vehicleLicences: [],
    languages: [],
    musicAndDance: [
      {
        facetId: 600,
        levelId: 5,
      },
      {
        facetId: 848,
        levelId: 5,
      },
      {
        facetId: 615,
        levelId: 5,
      },
      {
        facetId: 608,
        levelId: 5,
      },
      {
        facetId: 797,
        levelId: 5,
      },
    ],
    otherSkills: [],
    performances: [],
    sports: [
      {
        facetId: 1758,
        levelId: 9,
      },
    ],
    presenting: [],
    measurements: [
      {
        measurementType: "Height",
        value: 152,
      },
    ],
    credits: [
      {
        typeId: 0,
        role: "Lost Boy",
        name: "Peter Pan",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "Qdos Pantomimes Ltd",
        director: "Daryl Back",
        highlighted: false,
        position: 7,
      },
      {
        typeId: 12,
        role: "Younger Dave",
        name: "Brighton",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Brighton",
        director: "Stephen Cookson",
        highlighted: false,
        position: 3,
      },
      {
        typeId: 0,
        role: "Jr Dancer",
        name: "Chitty Chitty Bang Bang",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "White Rock Theatre Company",
        director: "Ben Watson",
        highlighted: false,
        position: 2,
      },
      {
        typeId: 4,
        role: "Grandson",
        name: "NS&I",
        dateTo: "2014-01-01T00:00:00+00:00",
        company: "Smuggler",
        director: "Jamie Rafn",
        highlighted: false,
        position: 12,
      },
      {
        typeId: 0,
        role: "Gang Boy",
        name: "Annie",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "Hastleons",
        director: "Royah Hamed",
        highlighted: false,
        position: 9,
      },
      {
        typeId: 0,
        role: "Jr Dancer",
        name: "Grease",
        dateTo: "2018-01-01T00:00:00+00:00",
        company: "White Rock Theatre Company",
        director: "Ben Watson",
        highlighted: false,
        position: 4,
      },
      {
        typeId: 0,
        role: "Jr Dancer/ Vocal Chorus",
        name: "WestEnd Experience",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "WestEnd Experience",
        director: "",
        highlighted: false,
        position: 6,
      },
      {
        typeId: 4,
        role: "Young Boy",
        name: "NSPCC Voices",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "WPN",
        director: "Sandra Money",
        highlighted: false,
        position: 11,
      },
      {
        typeId: 4,
        role: "Boy",
        name: "Amazon App",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "Rattling Stick",
        director: "Andy McLeod",
        highlighted: false,
        position: 10,
      },
      {
        typeId: 4,
        role: "Vinyl Boy",
        name: "Specsavers",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "Specsavers",
        director: "Katherine Blom",
        highlighted: false,
        position: 5,
      },
      {
        typeId: 4,
        role: "Child",
        name: "Amazon Prime Football",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Amazon Prime",
        director: "",
        highlighted: false,
        position: 1,
      },
      {
        typeId: 0,
        role: "Boy",
        name: "The Gang",
        dateTo: "2013-01-01T00:00:00+00:00",
        company: "The White Rock Theatre",
        director: "Kitson Wellard",
        highlighted: false,
        position: 13,
      },
      {
        typeId: 4,
        role: "Space Son",
        name: "Dreams",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "Dreams",
        director: "Phil Hawkins",
        highlighted: false,
        position: 8,
      },
    ],
    creditHeadings: [
      {
        orderByDate: false,
        isHidden: true,
        position: 2,
        creditType: {
          id: 0,
          name: "Stage",
          hasVenue: true,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 0,
        creditType: {
          id: 4,
          name: "Commercial",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 1,
        creditType: {
          id: 12,
          name: "Film",
          hasVenue: false,
        },
      },
    ],
    isPregnant: false,
    playingAgeFrom: 9,
    playingAgeTo: 13,
    dateOfBirthUtc: "2008-02-15T00:00:00+00:00",
    height: 152,
    viewPin: "6298-9056-5633",
    isVisibleActualAge: true,
    isVisibleDisability: false,
    isVisibleGender: false,
    isLicenseRequired: true,
  },
  {
    id: "9d97513c-87db-4edb-a862-d8aba37583c7",
    artistRef: "M194212",
    mainPhoto: {
      id: "0069c2f8-2b33-438a-88e4-533e47f17b71",
      fileName: "M00194212-1601",
      description: "",
      photographer: {
        name: "John Clark",
      },
    },
    galleryPhotos: [
      {
        position: 1,
        isHidden: true,
        id: "0f1c2662-512c-4f6c-ae10-b25f725600ee",
        fileName: "M00194212-16",
        photographer: {
          name: "John Clark",
        },
      },
    ],
    forename: "LUKE",
    surname: "CHEESMAN",
    performerType: "YoungPerformer",
    publicationCode: 16,
    contract: {
      membership: "youngperformerfamily",
      status: "current",
      expirationDate: "2020-05-12T00:00:00+00:00",
    },
    mainAgent: {
      agentRef: 1588,
      name: "SYLVIA YOUNG AGENCY & THEATRE SCHOOL",
      email: "enquiries@spotlight.com",
      phone: "020 7437 7631",
      mobilePhone: "020 7437 7631",
      website: "www.spotlight.com",
      address: {
        id: 111,
        addressLine1: "Spotlight",
        addressLine2: "7 Leicester Place",
        addressLine3: "London",
        addressLine4: "",
        country: "",
        postCode: "WC2H 7RJ",
      },
    },
    agents: [
      {
        agentRef: 1588,
        name: "SYLVIA YOUNG AGENCY & THEATRE SCHOOL",
        email: "enquiries@spotlight.com",
        phone: "020 7437 7631",
        mobilePhone: "020 7437 7631",
        website: "www.spotlight.com",
        address: {
          id: 111,
          addressLine1: "Spotlight",
          addressLine2: "7 Leicester Place",
          addressLine3: "London",
          addressLine4: "",
          country: "",
          postCode: "WC2H 7RJ",
        },
      },
    ],
    dramaSchools: [],
    showreelsCount: 0,
    audioclipsCount: 0,
    locations: [],
    castingDirectorNotes: [],
    gender: [5203],
    disabilities: [],
    nationalities: [],
    appearances: [1716],
    eyeColours: [247],
    facialHairs: [],
    hairColours: [266],
    hairLength: [277],
    beltNotes: [],
    accentsAndDialects: [
      {
        facetId: 20,
        levelId: 2,
      },
    ],
    vehicleLicences: [],
    languages: [],
    musicAndDance: [
      {
        facetId: 624,
        levelId: 6,
      },
      {
        facetId: 611,
        levelId: 6,
      },
      {
        facetId: 835,
        levelId: 5,
      },
    ],
    otherSkills: [],
    performances: [],
    sports: [
      {
        facetId: 1762,
        levelId: 10,
      },
      {
        facetId: 1738,
        levelId: 10,
      },
    ],
    presenting: [],
    measurements: [
      {
        measurementType: "Height",
        value: 149,
      },
    ],
    credits: [
      {
        typeId: 4,
        role: "Presenter",
        name: "It's My Friday",
        dateTo: "2014-01-01T00:00:00+00:00",
        company: "Disney Channel",
        director: "Nam Patel",
        highlighted: false,
        position: 4,
      },
      {
        typeId: 6,
        role: "VoiceOver",
        name: "Albert Walla Session",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "Side UK",
        director: "Matt Delamere",
        highlighted: false,
        position: 3,
      },
      {
        typeId: 0,
        role: "Child actor",
        name: "Good Night Mr Tom",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "Fiery Angel",
        director: "Angus Jackson",
        highlighted: false,
        position: 1,
      },
      {
        typeId: 0,
        role: "Child Actor",
        name: "Impossible",
        dateTo: "2015-01-01T00:00:00+00:00",
        company: "Delfont Mackintosh",
        director: "Jamie Hendry",
        highlighted: false,
        position: 2,
      },
    ],
    creditHeadings: [
      {
        orderByDate: false,
        isHidden: true,
        position: 1,
        creditType: {
          id: 0,
          name: "Stage",
          hasVenue: true,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 0,
        creditType: {
          id: 4,
          name: "Commercial",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 2,
        creditType: {
          id: 6,
          name: "Voice Over",
          hasVenue: false,
        },
      },
    ],
    isPregnant: false,
    playingAgeFrom: 9,
    playingAgeTo: 15,
    dateOfBirthUtc: "2003-12-14T00:00:00+00:00",
    height: 149,
    viewPin: "1893-5614-2003",
    isVisibleActualAge: false,
    isVisibleDisability: false,
    isVisibleGender: false,
    isLicenseRequired: false,
  },
  {
    id: "044241fa-ac49-476a-9587-5ff1e8207a87",
    artistRef: "M173068",
    mainPhoto: {
      id: "f7e780c9-55d1-47bd-ba00-168067c6029a",
      fileName: "d19c1977-a03e-4220-9f93-984cc483138d",
      description: "",
      photographer: {
        name: "Kim Hardy",
      },
    },
    galleryPhotos: [
      {
        position: 6,
        isHidden: false,
        id: "2c7e0920-8b5f-4168-9240-3b1bee6a77ee",
        fileName: "M00173068-1807",
        description: "",
        photographer: {
          name: "Aimee Spinks",
        },
      },
      {
        position: 5,
        isHidden: false,
        id: "df093382-3ad2-4d12-8e8a-5a3412d825ca",
        fileName: "M00173068-1809",
        description:
          "As Bomber in THE PICNIC, Royal Birmingham Conservatoire production",
        photographer: {
          name: "Greg Milner",
        },
      },
      {
        position: 4,
        isHidden: false,
        id: "43fc90bd-71bd-416f-aca5-c402fc8d9144",
        fileName: "M00173068-1805",
        description:
          "As Silvius in AS YOU LIKE IT, Royal Birmingham Conservatoire",
        photographer: {
          name: "Aimee Spinks",
        },
      },
      {
        position: 3,
        isHidden: false,
        id: "4cbdb7f1-eb85-4baf-af72-dbfd72565a6c",
        fileName: "b6f30759-1afa-4b01-bfae-e13242b4b7ef",
        description: "",
        photographer: {
          name: "Kim Hardy",
        },
      },
      {
        position: 0,
        isHidden: false,
        id: "c8ab0974-2178-4424-97d0-dc01b9bff3cf",
        fileName: "92b4fd41-9f73-4f43-9c22-b8e906573c3e",
        description: "",
        photographer: {
          name: "Kim Hardy",
        },
      },
      {
        position: 1,
        isHidden: false,
        id: "f2601233-8ee7-4ee9-a65a-e7122a6c6588",
        fileName: "73c0001f-5630-4ef0-ac70-5246d23fd540",
        description: "",
        photographer: {
          name: "Kim Hardy",
        },
      },
      {
        position: 2,
        isHidden: false,
        id: "86c65200-95c1-46bb-bf57-f43cc53e8d32",
        fileName: "bac310c7-6232-4309-bd40-c876cc8a772b",
        description: "",
        photographer: {
          name: "Kim Hardy",
        },
      },
    ],
    forename: "LUKE",
    surname: "DANIELS",
    performerType: "Performer",
    publicationCode: 1,
    contract: {
      membership: "performerfamily",
      status: "current",
      expirationDate: "2020-05-12T00:00:00+00:00",
    },
    mainAgent: {
      agentRef: 1922,
      name: "C C M",
      email: "enquiries@spotlight.com",
      phone: "020 7437 7631",
      mobilePhone: "020 7437 7631",
      website: "www.spotlight.com",
      address: {
        id: 111,
        addressLine1: "Spotlight",
        addressLine2: "7 Leicester Place",
        addressLine3: "London",
        addressLine4: "",
        country: "",
        postCode: "WC2H 7RJ",
      },
    },
    agents: [
      {
        agentRef: 1922,
        name: "C C M",
        email: "enquiries@spotlight.com",
        phone: "020 7437 7631",
        mobilePhone: "020 7437 7631",
        website: "www.spotlight.com",
        address: {
          id: 111,
          addressLine1: "Spotlight",
          addressLine2: "7 Leicester Place",
          addressLine3: "London",
          addressLine4: "",
          country: "",
          postCode: "WC2H 7RJ",
        },
      },
      {
        agentRef: 6792,
        name: "ROYAL BIRMINGHAM CONSERVATOIRE",
        email: "enquiries@spotlight.com",
        phone: "020 7437 7631",
        mobilePhone: "020 7437 7631",
        website: "www.spotlight.com",
        address: {
          id: 111,
          addressLine1: "Spotlight",
          addressLine2: "7 Leicester Place",
          addressLine3: "London",
          addressLine4: "",
          country: "",
          postCode: "WC2H 7RJ",
        },
      },
    ],
    dramaSchools: [],
    showreelsCount: 1,
    audioclipsCount: 6,
    locations: [],
    castingDirectorNotes: [],
    gender: [5203],
    disabilities: [],
    nationalities: [2198, 2134],
    appearances: [1716],
    eyeColours: [251],
    facialHairs: [],
    hairColours: [275],
    hairLength: [277],
    beltNotes: [5104],
    accentsAndDialects: [
      {
        facetId: 43,
        levelId: 1,
      },
      {
        facetId: 164,
        levelId: 2,
      },
      {
        facetId: 49,
        levelId: 1,
      },
      {
        facetId: 38,
        levelId: 1,
      },
      {
        facetId: 44,
        levelId: 1,
      },
      {
        facetId: 20,
        levelId: 1,
      },
      {
        facetId: 42,
        levelId: 1,
      },
      {
        facetId: 163,
        levelId: 1,
      },
      {
        facetId: 176,
        levelId: 1,
      },
      {
        facetId: 5,
        levelId: 1,
      },
    ],
    vehicleLicences: [],
    languages: [],
    musicAndDance: [
      {
        facetId: 623,
        levelId: 5,
      },
      {
        facetId: 824,
        levelId: 5,
      },
      {
        facetId: 844,
        levelId: 5,
      },
      {
        facetId: 636,
        levelId: 5,
      },
      {
        facetId: 629,
        levelId: 6,
      },
      {
        facetId: 742,
        levelId: 5,
      },
    ],
    otherSkills: [
      {
        facetId: 926,
      },
      {
        facetId: 1099,
      },
      {
        facetId: 959,
      },
      {
        facetId: 937,
      },
      {
        facetId: 954,
      },
    ],
    performances: [
      {
        facetId: 1538,
        levelId: 7,
      },
      {
        facetId: 1435,
        levelId: 7,
      },
      {
        facetId: 1373,
        levelId: 7,
      },
      {
        facetId: 1331,
        levelId: 7,
      },
      {
        facetId: 1354,
        levelId: 7,
      },
      {
        facetId: 1338,
        levelId: 7,
      },
      {
        facetId: 1328,
        levelId: 7,
      },
      {
        facetId: 1408,
        levelId: 7,
      },
      {
        facetId: 1541,
        levelId: 7,
      },
    ],
    sports: [
      {
        facetId: 1734,
        levelId: 9,
      },
      {
        facetId: 1930,
        levelId: 9,
      },
      {
        facetId: 1750,
        levelId: 9,
      },
      {
        facetId: 1780,
        levelId: 9,
      },
      {
        facetId: 1757,
        levelId: 9,
      },
      {
        facetId: 1760,
        levelId: 9,
      },
      {
        facetId: 1743,
        levelId: 9,
      },
    ],
    presenting: [],
    measurements: [
      {
        measurementType: "LowerVocalNote",
        value: 27,
      },
      {
        measurementType: "Weight",
        value: 66.22,
      },
      {
        measurementType: "Height",
        value: 167,
      },
      {
        measurementType: "UpperVocalNote",
        value: 52,
      },
    ],
    credits: [
      {
        typeId: 0,
        role: "Robin/Ollie/Bell Boy/Mr Lord",
        name: "Howard Katz",
        dateTo: "2018-01-01T00:00:00+00:00",
        company: "Royal Birmingham Conservatoire",
        director: "John Adams",
        highlighted: false,
        position: 6,
      },
      {
        typeId: 8,
        role: "Simon",
        name: "Checkmate",
        dateTo: "2018-01-01T00:00:00+00:00",
        company: "BCU",
        director: "Sarah Canning",
        highlighted: false,
        position: 11,
      },
      {
        typeId: 4,
        role: "Teenage Son",
        name: "Tesco Christmas",
        dateTo: "2014-01-01T00:00:00+00:00",
        company: "Tesco",
        director: "",
        highlighted: false,
        position: 13,
      },
      {
        typeId: 13,
        role: "Young Clyde/Archie/Joe",
        name: "Bonnie & Clyde The Musical",
        dateTo: "2018-01-01T00:00:00+00:00",
        company: "Royal Birmingham Conservatoire",
        director: "Lisa Olsen",
        highlighted: false,
        position: 1,
      },
      {
        typeId: 0,
        role: "Romeo",
        name: "Romeo and Juliet",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Young Shakespeare Company",
        director: "Christopher Geelan",
        highlighted: false,
        position: 2,
      },
      {
        typeId: 4,
        role: "Featured Customer",
        name: "Maplins (Sponsoring The Gadget Man)",
        dateTo: "2014-01-01T00:00:00+00:00",
        company: "Maplins",
        director: "",
        highlighted: false,
        position: 12,
      },
      {
        typeId: 0,
        role: "Konstantine",
        name: "The Seagull",
        dateTo: "2016-01-01T00:00:00+00:00",
        company: "Royal Birmingham Conservatoire",
        director: "Hannah Kaye",
        highlighted: false,
        position: 8,
      },
      {
        typeId: 0,
        role: "Lee Harvey Oswald",
        name: "The Terror (A Devised Physical Theatre Piece)",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "Royal Birmingham Conservatoire",
        director: "Steven Simms",
        highlighted: false,
        position: 4,
      },
      {
        typeId: 0,
        role: "Gino",
        name: "Conversations With Myself",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "SyncOrSwim Productions",
        director: "Leo Benedict",
        highlighted: false,
        position: 3,
      },
      {
        typeId: 0,
        role: "Silvius",
        name: "As You Like It",
        dateTo: "2018-01-01T00:00:00+00:00",
        company: "Royal Birmingham Conservatoire",
        director: "Scott Ellis",
        highlighted: false,
        position: 5,
      },
      {
        typeId: 0,
        role: "Harry Hardcastle",
        name: "Love on the dole",
        dateTo: "2017-01-01T00:00:00+00:00",
        company: "Royal Birmingham Conservatoire",
        director: "Louise Papillon",
        highlighted: false,
        position: 7,
      },
      {
        typeId: 8,
        role: "Jamie",
        name: "Siege at Turtle Head Point",
        dateTo: "2018-01-01T00:00:00+00:00",
        company: "BCU",
        director: "Clifford Milner",
        highlighted: false,
        position: 9,
      },
      {
        typeId: 8,
        role: "Paul",
        name: "When It Rains Gasoline",
        dateTo: "2019-01-01T00:00:00+00:00",
        company: "BCU",
        director: "Clifford Milner",
        highlighted: false,
        position: 10,
      },
    ],
    creditHeadings: [
      {
        orderByDate: false,
        isHidden: false,
        position: 0,
        creditType: {
          id: 0,
          name: "Stage",
          hasVenue: true,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 2,
        creditType: {
          id: 4,
          name: "Commercial",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: false,
        position: 1,
        creditType: {
          id: 8,
          name: "Short Film",
          hasVenue: false,
        },
      },
      {
        orderByDate: false,
        isHidden: true,
        position: 3,
        creditType: {
          id: 13,
          name: "Musical",
          hasVenue: true,
        },
      },
    ],
    isPregnant: false,
    playingAgeFrom: 16,
    playingAgeTo: 25,
    dateOfBirthUtc: "1997-02-06T00:00:00+00:00",
    height: 167,
    viewPin: "9179-0166-5460",
    isVisibleActualAge: false,
    isVisibleDisability: false,
    isVisibleGender: false,
  },
];

// @ts-ignore
export const MOCK_PERFORMERS = performerResponse as IPerformer[];
